webpackJsonp([3,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(63);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(34);
	
	var _App = __webpack_require__(596);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default);
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var english = exports.english = {
	  homeView: {
	    menuList: {
	      index: 'Home',
	      about: 'About US',
	      products: 'Products',
	      technology: 'Technology & Equipment',
	      contact: 'Contact Us',
	      synopsis: 'Auto Introduction',
	      develop: 'Auto History',
	      honor: 'Auto Honors',
	      team: 'Auto Team',
	      spring: 'Spring Series',
	      hardware: 'Metal Hardware Series',
	      echnicalAdvantages: 'Technical Advantage',
	      productionEquipment: 'Production Equipment',
	      inspectionEquipment: 'Testing Equipment',
	      workshopEnvironment: 'Workshop Environment'
	    }
	  },
	
	  footer: {
	    footerAbout: 'About Us',
	    footerProducts: 'Product',
	    footerTechnology: 'Technology & Equipment',
	    footerContact: 'Contact Us',
	    footerSynopsis: 'Auto Introduction',
	    footerDevelop: 'Auto History',
	    footerHonor: 'Auto Honors',
	    footerTeam: 'Auto Team',
	    footerSpring: 'Spring Series',
	    footerHardware: 'Metal Hardware Series',
	    footerEchnicalAdvantages: 'Technical Advantage',
	    footerProductionEquipment: 'Production Equipment',
	    footerInspectionEquipment: 'Testing Equipment',
	    footerWorkshopEnvironment: 'Workshop Environment',
	    footerTel: 'Tel：( 86 ) 20-8226 9339',
	    footerFax: 'Fax：( 86 ) 20-8226 9339',
	    footerEmail: 'Email：marketing@autospring.cn',
	    footerAddress: 'Address：Canglian Xiaodun East Road, Guangzhou Economic and Technological Development Zone, East District, Guangzhou, China',
	    footerInfo: 'Copyright 2023-2028 autospring.cn | AUTO SPRINGS All Rights Reserved | 粤ICP备14017194号-2'
	  },
	
	  indexPage: {
	    categoryNavigation: 'CATEGORY NAVIGATION',
	    classification: '',
	    springTitle: 'SPRING SERIES',
	    springTitleEN: '',
	    buttonText: 'VIEW DETAILS',
	    hardwareTitle: 'METAL HARDWARE SERIES',
	    hardwareTitleEN: '',
	    middleTitleOne: 'DIVERSE SPECIFICATION',
	    middleTitleTwo: 'HONEST <br /> BUSINESS',
	    middleTitleThree: 'CUSTOMISED PROCESSING',
	    middleTitleFour: 'PERFECT AFTERMARKET',
	    middleTitleFive: 'SUFFICIENT SUPPLY OF GOODS',
	    middleSubTitleOne: '',
	    middleSubTitleTwo: '',
	    middleSubTitleThree: '',
	    middleSubTitleFour: '',
	    middleSubTitleFive: '',
	    middleTextOneFir: 'VARIOUS PRODUCT SPECIFICATION',
	    middleTextOneSec: 'FULFILMENT OF YOUR NEEDS',
	    middleTextTwoFir: 'INTEGRITY AND WIN-WIN',
	    middleTextTwoSec: 'REAL MATERIALS RESPONSIBILITY',
	    middleTextThreeFir: 'SUPPORT',
	    middleTextThreeSec: 'PROCESSING CUSTOM',
	    middleTextFourFir: ' SERVICE',
	    middleTextFourSec: 'PURCHASE WITH CONFIDENCE',
	    middleTextFiveFir: 'SUFFICIENT SUPPLY',
	    middleTextFiveSec: 'OF GOODS LARGE',
	    aboutTitleEN: 'ABOUT US',
	    aboutTitleZH: '',
	    aboutListOne: 'Established in Hong Kong, 1984',
	    aboutListTwo: 'Established in 1998 with a registered capital of 30 million Hong Kong dollars, a Hong Kong-funded enterprise',
	    aboutListThree: 'Certificated ISO9001, ISO14001, IATF16949',
	    aboutListFour: 'Provide one-stop service mode for export, transfer and domestic sales',
	    aboutListFive: 'Covering an area of 25,500m², the practical plant area of 24,500m²',
	    aboutListSix: 'With an annual average of 620 personnel, two-shift production',
	    aboutListSeven: 'Specialised in the production of various types of springs and metal stamping products',
	    aboutListEight: 'Owns 330 sets of spring equipments and more than 50 sets of progressive die punches',
	    aboutListNine: 'Annual production capacity of 2.3 billion pieces of springs and 210 million pieces of stampings',
	    aboutDetails: 'VIEW DETAILS',
	    aboutFooterTitleOne: '“ Originated in 1984 ”',
	    aboutFooterTitleTwo: '“ Extensive Product Experience ”',
	    aboutFooterTitleThree: '“ Strong Production Capacity ”',
	    aboutFooterTitleFour: '“ Large Physical Plant ”',
	    aobutFooterNumOne: '39',
	    aobutFooterNumTwo: '500',
	    aobutFooterNumThree: '23',
	    aobutFooterNumFour: '24500',
	    aboutFooterUnitOne: 'Years',
	    aboutFooterUnitTwo: '+<br/>People',
	    aboutFooterUnitThree: '+<br/>Hundred Million',
	    aboutFooterUnitFour: 'm²',
	    aboutFooterExplainOne: 'Industry Experience',
	    aboutFooterExplainTwo: 'Production Staff',
	    aboutFooterExplainThree: 'Annual Production Of Springs',
	    aboutFooterExplainFour: 'Plant Area',
	    honorTitleZH: 'HONOURS AND CERTIFICATES',
	    honorTitleEN: '',
	    customerTitleZH: 'OUR CLIENTS',
	    customerTitleEN: ''
	  },
	
	  about: {
	    breadcrumb: 'CURRENT LOCATION： ABOUT US  >  ',
	    aboutTitleZH: 'About Us',
	    aboutTitleEN: '',
	    synopsis: 'Auto Introduction',
	    develop: 'Auto History',
	    honor: 'Auto Honours',
	    team: 'Auto Team',
	    phoneTitle: 'Service Customer Hotline:',
	    phoneNum: '+8620 8226 9286',
	    synTitleOneZH: 'Enterprise Introduction',
	    synTitleOneEN: '',
	    synTitleTwoZH: 'Enterprise Philosophy',
	    synTitleTwoEN: '',
	    synTitleTopOne: 'Spring  Factory',
	    synTitleTopTwo: 'Hardware  Factory',
	    aboutListOne: 'Established in Hong Kong, 1984',
	    aboutListTwo: 'Established in 1998 with a registered capital of 30 million Hong Kong dollars, a Hong Kong-funded enterprise',
	    aboutListThree: 'Certificated ISO9001, ISO14001, IATF16949',
	    aboutListFour: 'Provide one-stop service mode for export, transfer and domestic sales',
	    aboutListFive: 'Covering an area of 25,500m², the practical plant area of 24,500m²',
	    aboutListSix: 'With an annual average of 500 personnel, two-shift production',
	    aboutListSeven: 'Specialised in the production of various types of springs and metal stamping products',
	    aboutListEight: 'Owns 330 sets of spring equipments and more than 50 sets of progressive die punches',
	    aboutListNine: 'Annual production capacity of 2.3 billion pieces of springs and 210 million pieces of stampings',
	    philosophyTitleTwo: 'Enterprise Vision',
	    philosophyTitleOne: 'Enterprise Mission',
	    philosophyTitleThree: 'Enterprise Healthy Attitude',
	    philosophyTitleFour: 'Quality Policy',
	    philosophyTextTwo: 'Facing the world, realising industrial wisdom and achieving a hundred-year enterprise',
	    philosophyTextOne: 'Professional products and services for safer travelling. Make life more wonderful',
	    philosophyTextThree: 'Professionalism, Innovation, Pragmatism, Value ',
	    philosophyTextFour: 'Quality first, integrity and pragmatic, always climb new heights, sustainable development',
	    developmentTitleZH: 'Auto History',
	    developmentTitleEN: '',
	    developYearOne: '2019 To Date',
	    developYearTwo: '2000 Years',
	    developYearThree: '1984 Years',
	    developYearFour: '2003 Years',
	    developYearFive: '1998 Years',
	    developInfoOneCom: 'Auto Spring Hardware Branch Factory Expansion ( Baofeng Branch Factory )',
	    developInfoOneArea: 'Area: 11000 square metres',
	    developInfoFourCom: 'Guangzhou Auto Spring Co., Ltd. was established in Whampoa',
	    developInfoFourMain: 'Main business: precision springs, hardware stamping',
	    developInfoFourNum: 'Personnel: 480',
	    developInfoFourArea: 'Area: 13000 square metres',
	    developInfoTwoCom: 'Shenzhen Aoto Spring Co., Ltd. was established in Shenzhen Shajing',
	    developInfoTwoMain: 'Main business: Precision springs',
	    developInfoTwoNum: 'Personnel: 80',
	    developInfoTwoArea: 'Area: 4000 square metres',
	    developInfoFiveCom: 'Guangzhou Auto Spring Co., Ltd. was established in Dongpu, Guangzhou',
	    developInfoFiveMain: 'Main business: Precision springs',
	    developInfoFiveNum: 'Personnel: 80',
	    developInfoFiveArea: 'Area: 3000 square metres',
	    developInfoThreeCom: 'The company was established in Hong Kong',
	    developInfoThreeMain: 'Main business: Precision springs',
	    developInfoThreeNum: 'Personnel: 30',
	    developInfoThreeArea: 'Area: 1000 square metres',
	    honorTitleZH: 'Auto Honours',
	    honorTitleEN: '',
	    honorTitleOne: 'R&D Technology Centre ',
	    honorTextOne: 'The company has obtained a series of enterprise honours and qualifications. The company has passed the national high-tech enterprise certification in 2014, passed the Guangzhou municipal enterprise technology centre certification in 2015, and owns the famous trademark of Guangdong Province and the famous trademark of Guangzhou City. In 2017, the company will be certified as Guangdong Provincial Technology Centre, and in 2023, the company will be certified as Specialized, Specialized and New Small and Medium-sized Enterprises (SMEs).',
	    honorTitleTwo: 'Patents For Inventions ',
	    honorTextTwo: 'The company promotes an improvement culture and has more than forty invention patents.',
	    honorTitleThree: 'System Certificate',
	    honorTextThree: 'The company has obtained ISO9001:2015 , ISO14001:2015, IATF16949:2016 system certificates.',
	    honorTitleFour: 'Part Of The Enterprise Honours',
	    honorYearOne: '2011 Years',
	    honorYearTwo: '2013 Years',
	    honorYearThree: '2017 Years',
	    honorYearFour: '2018 Years',
	    honorYearFive: '2019 Years',
	    honorYearSix: '2022 Years',
	    honorYearSeven: '2023 Years',
	    honorYearEight: '2023 Years',
	    honorExplainOne: 'Awarded by BYD Auto Co.',
	    honorExplainOne02: 'Positive Co-operation Award',
	    honorExplainTwo: 'Awarded by Gore Acoustics Co.',
	    honorExplainTwo02: 'Best Competitiveness Award',
	    honorExplainThree: 'Awarded by Liuzhou Wuling <br /> Automobile Industry Co.',
	    honorExplainThree02: 'Excellent Supplier',
	    honorExplainFour: 'Awarded Alpha (Guangzhou) <br /> Auto Parts Co.',
	    honorExplainFour02: 'Excellent Supplier',
	    honorExplainFive: 'Awarded by Yushin Manufacturing <br />(Zhongshan) Co.',
	    honorExplainFive02: 'Excellent Supplier',
	    honorExplainSix: 'Awarded by Guangdong Gao Yi <br /> Industrial Machinery Co.',
	    honorExplainSix02: 'Excellent Supplier',
	    honorExplainSeven: 'Awarded Shanghai Enjing <br /> Automotive Technology Co.',
	    honorExplainSeven02: 'Excellent Quality Award',
	    honorExplainEight: 'Awarded by Fulin Precision (Corewise <br /> Thermal Control Technology) Co. ',
	    honorExplainEight02: 'Technical Contribution Award',
	    cultureTitleZH: 'Enterprise Culture',
	    cultureTitleEN: '',
	    cultureMainTextOne: 'After nearly three decades of operation, we are convinced that excellent corporate culture is the foundation of a good century of business, adhere to the people-oriented, integrity management, attach great importance to the shaping of corporate culture, the implementation of a sound management system, effective matching of people and jobs, transparent communication atmosphere, and insight and observation of subtle comprehensive assessment system. ',
	    cultureMainTextTwo: 'We have set up a trade union and carried out a number of activities every year, such as staff travel, physical examination, basketball, tug-of-war, billiard, 6S knowledge contest, and mould loading and unloading contests, etc., which prompts every staff to give full play to their enthusiasm and creativity, and shapes a highly cohesive and loyal team of high-quality staffs who are good at overcoming difficulties and providing constant power for the development of the company, and steadily Enhance the excellent core competitiveness of the enterprise.',
	    cultureTitleOne: 'Enterprise Culture - Extension Activities',
	    cultureImgTitleOne: 'Kick-Off Conference ',
	    cultureImgTitleTwo: 'Tug-Of-War ',
	    cultureImgTitleThree: 'Staff Travel ',
	    cultureImgTitleFour: 'Expansion Game',
	    cultureImgTitleFive: 'Outdoor Expansion',
	    cultureImgTitleSix: 'Outdoor Expansion',
	    cultureImgTitleSeven: 'Badminton Match',
	    cultureImgTitleEight: 'Staff Birthday Party',
	    cultureImgTitleNine: 'One-Star Team',
	    cultureTitleTwo: 'Enterprise Culture - Cultivate',
	    cultureTitleThree: 'Enterprise Culture - Enhancement',
	    cultureTextOne: 'Every year, the company carries out large and small training and sand table activities for more than 2,000 participants.',
	    cultureTextTwo: 'The company continuously improves and innovates: about 300 improvement proposals per year, about 500 improvements per week, and carries out the spirit of 10 major improvements.',
	    cultureMationTitle: 'Ten Spirits Of Improvement',
	    cultureMationTextOne: 'Break the stereotypes and dare to deny the status quo',
	    cultureMationTextTwo: 'Find what works. Don\'t say "no."',
	    cultureMationTextThree: 'Don\'t argue, execute quickly',
	    cultureMationTextFour: 'I don\'t want it to be perfect, 50 cents is fine, implement it immediately.',
	    cultureMationTextFive: 'Wrong. Improve it right away.',
	    cultureMationTextSix: 'Improvement without limits',
	    cultureMationTextSeven: 'When there is a problem, the first thing that comes to mind is your own responsibility',
	    cultureMationTextEight: 'Go to the root of the problem. Repeat "Why?" five times.',
	    cultureMationTextNine: 'The wisdom of ten is superior to that of one.',
	    cultureMationTextTen: 'Start with improvements that don\'t cost anything.',
	    technicalTitleZH: 'Technical Staff ',
	    technicalTitleEN: '',
	    industryTitleZH: 'Industry Position',
	    industryTitleEN: '',
	    industryTextOne: 'Develop and produce products mainly used in automobiles, aviation appliances, high-precision circuit controllers, household appliances, office electronic computers, mobile phone communications, architectural hardware, medical equipment and other industrial products around the world in all areas of the use of springs and precision stamping hardware components, such as more than 30 industry international advanced technology.',
	    industryTextTwo: 'We provide one-stop service for Bosch, Honda, General Electric, Valeo, BYD, Magna, Apple, Hewlett-Packard, Mitsubishi Compressor, Kyosei Heavy Industries and other internationally renowned customers, and have won a number of honours. Successively with the Swedish Spring Association Lesjofors Group, Germany Spring Tec Group Group, South China Institute of Metal Research, Sinosteel Group Zhengzhou Metal Products Research Institute, Guizhou Steel Rope Joint Stock Technology Centre, scientific research and production consortium. <br /><br /> <p class="cultureMainText">At the same time pay attention to the introduction, training of various types of professional and technical personnel, the establishment of a high-quality scientific research and development team, the products belong to high-tech precision parts, the production process is highly automated, the technology is at the leading level in China, the annual production and sales volume are among the top in China, the quality of products to reach the same kind of advanced or leading level at home and abroad.</p>',
	    domesticTitleZH: 'National Status',
	    domesticTitleEN: '',
	    domesticTextOne: 'Auto Springs is one of the manufacturers with the widest range of wire diameter (0.03-16mm), the largest production capacity, as well as supporting the production of hardware stamping products and parts, strong technical strength, and the widest range of customer products; it has participated in the revision of the new standards for carbon steel wire for springs for many times, and has participated in the cooperation units of the national technical standardisation.',
	    domesticTextTwo: 'The company\'s technology research and development centre relies on its own exploration for many years, to overcome domestic and foreign technical barriers, to participate in customer design and development of a number of springs and hardware products, applied for more than 40 patents, and fill the gaps of similar products in the country, such as dual-line simultaneous coiling spring technology and products, ultra-fine tower type safety position spring, automatic tailgate springs, the successful development of the VVT project to put an end to the monopoly of Germany and Italy, which must be relied on imports, reduce customer costs and quickly and effectively reduce the cost and reduce the cost of the company\'s products. The successful research and development of VVT project has ended the monopoly of imported German and Italian products, lowered the cost of customers and enabled us to respond quickly to customer needs.',
	    strategicTitleZH: 'Strategic Planning',
	    strategicTitleEN: '',
	    strategicText: 'Thanks to China\'s continuous development and growth in the global market, we keep close to the pulse of the market, adhere to independent research and development, continuous innovation, over the past 30 years, continuous improvement, to overcome the technical difficulties and market challenges one at a time, and won a high degree of recognition of domestic and foreign customers, in the future, the company\'s main market competition will be even more intense, we will continue to deepen the ploughing of the following main business.',
	    objectiveTitleZH: 'Strategic Objective',
	    objectiveTitleEN: '',
	    objectiveTextOne: '2025 Revenues expected to be $845 million',
	    objectiveTextTwo: '2024 Revenues expected to be $650 million ',
	    objectiveTextThree: '2023 Revenues expected to be $500 million '
	  },
	
	  contact: {
	    bannerTitleOne: 'IT ALL STARTS WITH LISTENING',
	    bannerTitleTwo: '',
	    bannerTitleThree: '',
	    bannerText: 'Let us know your needs and let our great team serve you!',
	    breadcrumb: 'Current Position: Contact Us',
	    contactTitleZH: 'Contact Us',
	    contactTitleEN: '',
	    compNameZH: 'GUANGZHOU<br /> AUTO SPRING CO.,LTD.',
	    compNameEN: '',
	    compAdd: 'Address：Xiaodan East Road, Huangpu District, Guangzhou City, Guangdong Province, China',
	    compTel: 'Tel：( 86 ) 20-8226 9339',
	    compFax: 'Fax：( 86 ) 20-8226 9339',
	    compZip: 'Postcode：510760',
	    compEmail: 'Email：marketing@autospring.cn',
	    compWeb: 'Website：www.autospring.cn',
	    phoneTitleZH: 'Customer Hotline：',
	    phoneNum: '+8620 8226 9286'
	  },
	
	  technology: {
	    bannerTitleOne: 'YOUR SATISFACTION',
	    bannerTitleTwo: 'IS THE EXPRESSION OF OUR PROFESSIONALISM',
	    bannerTitleThree: 'More than 30 years of industry experience, colourful professional experience and execution ability',
	    bannerTitleFour: 'Successfully serve tens of thousands of customers',
	    breadcrumb: 'Current Position: Technology & Equipment > ',
	    technologyTitleZH: 'Technology & Equipment',
	    technologyTitleEN: '',
	    advantage: 'Technical Advantage',
	    produce: 'Production Equipment',
	    detect: 'Testing Equipment',
	    environment: 'Workshop Environment',
	    phoneTitle: 'Service Customer Hotline:',
	    phoneNum: '+8620 8226 9286',
	    advantageTitleZH: 'Technical Advantage',
	    advantageTitleEN: '',
	    advantageMainTitleOne: 'Technical Advantages - Springs',
	    advantageMainTitleTwo: 'Technical Advantages - Hardware',
	    listTitleOne: 'STRONG PROCESS AND EQUIPMENT DEVELOPMENT CAPABILITIES',
	    listTextOne: 'The company\'s technology research and development centre relies on its own many years of exploration, to overcome domestic and foreign technical barriers, participate in customer design and development of a number of springs and hardware products, applied for more than 40 patents, and to fill the gaps in similar products in the country, such as dual-line simultaneous coiling of the spring process and products, the ultra-fine tower-type safety position springs, the automatic tailgate spring, the successful development of the VVT project to end the monopoly must rely on imports of the German system and the Italian system, to reduce the cost of the customer and to respond quickly to customer demand.',
	    listTitleTwo: 'COMPREHENSIVE AND PROFESSIONAL TEST AND INSPECTION CAPABILITIES',
	    listTextTwo: 'We have more than 20 sets of advanced fully automatic and high precision mechanical measuring equipment, with a minimum reading value of 0.001N, more than 10 sets of optical image and 3D measurement, and more than 10 sets of various types of environmental and constant temperature and humidity testing, which can provide comprehensive and professional technical and quality reports on the mechanics of the materials and products, spatial dimensions, material properties and metallurgical organisational structure, surface corrosion resistance, different temperatures of the relaxation, fatigue characteristics, cleanliness and so on. The company also develops and applies a large number of At the same time, the company has also developed and applied a large number of online testing technology.',
	    listTitleThree: 'PROFESSIONAL R&D TEAM',
	    listTextThree: 'The company has more than 30 experienced metal materials, automation control professional technology research and development backbone, according to the customer\'s design concept or use of working conditions, based on finite element through CAE analysis, to provide professional spring structure, stress calculation, fatigue analysis and other design recommendations, so that the design becomes more reasonable and safer. Professional team to expand the function of the equipment, add error-proof warning and safety devices; self-development of special equipment and special tooling.',
	    listTitleFour: 'PROFESSIONAL TOOLING <br /> MOULD MAKING',
	    listTextFour: '"China Smart Manufacturing" not only embodies automation and intelligence, but also must ensure the stability of the process capability as a prerequisite, which requires the professional design of our experienced PE staff and high-precision various types of CNC moulding and jig processing equipment as a guarantee.',
	    listTitleFive: 'EXTENSIVE PRODUCT LINE',
	    listTextFive: 'We have more than 300 sets of various types of CNC spring processing equipment and more than 50 sets of (16-300T) progressive die punches and die processing equipment, wire diameter covering 0.03mm-16mm, plate thickness 0.05-5mm, can process steel, iron, aluminium, rare alloys, stainless steel, copper and its alloys, etc., to provide customers with a variety of efficient and professional solutions.',
	    listTitleSix: 'A WIDE RANGE OF SURFACE <br /> TREATMENT TECHNOLOGIES',
	    listTextSix: 'Low temperature nitriding, MAGNI, flocking, modified powder organic composite coating, thick gold plating and so on. Improve corrosion resistance, friction resistance, noise reduction and fatigue effect at the same time.',
	    listTitleSeven: 'PROFESSIONAL <br /> ENGINEERING TEAM',
	    listTextSeven01: '★  Technical team familiar with IATF16949 system',
	    listTextSeven02: '',
	    listTextSeven07: '★  Familiar with systematic new product development process and customer system',
	    listTextSeven03: '★  Rich experience in material selection, reasonable process planning',
	    listTextSeven04: '★  CAE analysis ability, experience in cooperating with customers\' research and development',
	    listTextSeven05: '★  Rich experience in designing and producing moulds for automobiles and precision electronics',
	    listTextSeven06: '★  Rich experience in product development process problem countermeasures and solutions',
	    listTitleEight01: 'STRONG SPECIALISED MANUFACTURING <br /> TOOLING AND EQUIPMENT',
	    listTitleEight02: 'DEVELOPMENT CAPABILITY',
	    listTextEight01: '★  Capability to develop dedicated parts assembly equipment',
	    listTextEight02: '★  Capability to develop dedicated press peripheral auxiliary equipment',
	    listTextEight03: '★  Development of dedicated post-process reduction equipment and facilities Capabilities',
	    listTitleNine01: 'STRONG SPECIALISED TESTING <br /> TOOLING AND EQUIPMENT',
	    listTitleNine02: 'DEVELOPMENT CAPABILITY',
	    listTextNine01: '★  CCD full inspection equipment development capability',
	    listTextNine02: '★  Specialised hermeticity testing equipment development capability',
	    listTextNine03: '★  Specialised testing fixtures development capability',
	    listTextNine04: '★  Capability to develop other special test equipment, etc.',
	    listTitleTen01: 'VARIOUS TYPES OF <br /> STAMPING MOULDS',
	    listTitleTen02: 'DEVELOPMENT EXPERIENCE',
	    listTextTen01: '★  630T or less continuous mould development',
	    listTextTen02: '★  630T and below robot transfer mould development',
	    listTextTen03: '★  High-precision stretching continuous and transfer mould development',
	    listTextTen04: '★  Material thickness 0.1~6mm range mould development',
	    listTitleEle: 'WIDE RANGE OF <br /> MATERIAL ADAPTABILITY',
	    listTextEle01: '★  Extensive experience in process planning and structural design Capability',
	    listTextEle02: '★  Precision processing and manufacturing equipment',
	    listTextEle03: '★  Strong supply chain system',
	    listTextEle04: '★  Meet all kinds of aluminium, copper, alloy, 0.1~6MM thickness stainless steel, high strength plate, tensile materials, etc. 0.1~6MM thickness of stainless steel, high strength plate, tensile materials, etc. Stamping Processing',
	    listTitleTwe: 'WIDE-RANGING AND <br /> DIVERSE PRODUCT LINE',
	    listTextTwe01: '★  Continuous stamping manufacturing capacity of more than 50 machines in the 16~400T range',
	    listTextTwe02: '★  Matching mould manufacturing capacity',
	    listTextTwe03: '★  Supporting special tooling manufacturing capacity',
	    listTextTwe04: '★  Supporting cleaning and degreasing capabilities',
	    listTextTwe05: '★  Supporting post-production line processing capability',
	    listTitleThi: 'STRONG SUPPLIER <br /> INTEGRATION CAPABILITIES',
	    listTextThi01: '★  Familiarity with industry conditions for each key position holder',
	    listTextThi02: '★  Procurement big data management system support',
	    listTextThi03: '★  Strong supplier preference, evaluation, and management system',
	    listTextThi04: '★  Ability to fully utilise industry resources',
	    listTextThi05: '★  One-step ahead of the rapid response capability',
	    produceTitleZH: 'Production & Equipment',
	    produceTitleEN: '',
	    produceMainTitleOne: 'Production Equipment - Springs',
	    produceMainTitleTwo: 'Production Facilities - Hardware ',
	    produceTitleNum: 'Equipment quantity：',
	    produceTitleSpecialty: 'Equipment features：',
	    produceTitleMain: 'Main product：',
	    produceTitleDay: 'Daily output：',
	    produceTitleMonth: 'Monthly output：',
	    produceTitleYear: 'Annual output：',
	    produceListTitleOne: 'AUTOMATIC STRING SETTING EQUIPMENT',
	    produceListTextOne: 'Facing the high cost of manpower, we used to rely on the manual work of the personnel, but through independent research and development of equipment, the product through the automatic production line to complete the process requirements, improve production efficiency and reduce manufacturing costs.',
	    produceListTitleTwo: 'AUTOMATIC MULTIFUNCTIONAL CONER FOLDING MACHINE',
	    produceListTextTwo: 'For automotive door lock lever products for independent research and development of special cornering equipment, efficiency increased by 50%.',
	    produceListTitleThree: 'AUTOMATIC ROTARY FORGING MACHINE',
	    produceListTextThree: 'For automotive door lock lever products for independent research and development of special rotary forging equipment, breaking the original rotary forging equipment processing way of thinking, efficiency increased by 50%; specifically set up six production lines for the production of lever products.',
	    produceListTitleFour: 'TAIWAN PRECISION COMPRESSION SPRING MACHINE',
	    produceListTextFour01: '60 sets',
	    produceListTextFour02: 'high precision equipment, high stability of the production of products, the minimum tolerance of the product warping can be controlled at 0.01mm, length tolerance can be controlled at 0.02mm; each machine is equipped with an automatic length checker, automatic monitoring of the length of the product during the production process, the length of the deviation can be repaired automatically, beyond the tolerance range of the automatic separation function, to effectively ensure product quality.',
	    produceListTextFour03: 'pressure springs above φ0.1.',
	    produceListTextFour04: '50 million PCS',
	    produceListTitleFive: 'TAIWAN 7-AXIS LARGE COMPRESSION SPRING MACHINE',
	    produceListTextFive01: '5 sets',
	    produceListTextFive02: '7-axis individual operation; easy to change type; high efficiency',
	    produceListTextFive03: ' Various kinds of large compression springs over φ3.0. At present, it mainly produces automobile clutches, engines, and automobile tailgate type products.',
	    produceListTextFive04: '4.5 million PCS',
	    produceListTitleSix: 'TAIWAN PRECISION TENSION SPRING MACHINE',
	    produceListTextSix01: '15 sets',
	    produceListTextSix02: 'equipment, high precision, high stability of the production of tension spring products',
	    produceListTextSix03: 'ordinary German, British type tension springs, products are mainly used in electronic appliances, switches, etc., can be produced in the range of φ0.1mm-φ0.8mm wire diameter tension springs',
	    produceListTextSix04: '5 million PCS',
	    produceListTitleSeven: 'JAPAN MEC MULTI-FUNCTION SPRING MACHINE',
	    produceListTextSeven01: '15 sets',
	    produceListTextSeven02: 'specialised in the production of 0.03mm - 0.3mm wire diameter range of all types of small products, mainly used in precision electronics or medical products.',
	    produceListTextSeven03: '20 million PCS',
	    produceListTitleEight: '12-AXIS MULTIFUNCTIONAL SPRING MACHINE',
	    produceListTextEight01: ' 12-axis respectively for individual servo motor control, conversion of product type efficient, save the time of the personnel row cam, the production of 0.3mm-2.0mm wire diameter range of various types of products, the main production of shaped tension springs, torsion springs, wire forming products',
	    produceListTextEight02: '50 million PCS',
	    produceListTitleNine: '12-AXIS LARGE-SCALE MULTIFUNCTIONAL SPRING MACHINE',
	    produceListTextNine01: '15 sets',
	    produceListTextNine02: '12-axis individual operation; easy to change type; high efficiency',
	    produceListTextNine03: 'all kinds of torsion springs, tension springs and wire forming above φ3.0.',
	    produceListTextNine04: '4.5 million PCS',
	    produceListTitleTen: '45T-630T CONTINUOUS PUNCHING MACHINE',
	    produceListTextTen01: '50 sets',
	    produceListTextTen02: 'Jinfeng/Dongtai/Guangforging',
	    produceListTextTen03: '<br />Precision punching machine, stable performance, can produce material thickness 0.1mm-6.0mm all kinds of materials, precision hardware stamping products and chassis and other tensile products.',
	    produceListTitleEleven: '10T-38T PRECISION FORMING MACHINE(BUCKLING MACHINE)',
	    produceListTextEleven01: '9 sets',
	    produceListTextEleven02: 'Taiwan Yisheng',
	    produceListTextEleven03: '<br />Suitable for the production of ball springs and card springs made of galvanised wire, stainless steel and other materials with a diameter of 0.1mm-5.0mm.',
	    produceListTitleTwelve: 'FULLY AUTOMATIC HYDROCARBON CLEANING MACHINE',
	    produceListTextTwelve01: '2 sets',
	    produceListTextTwelve02: ' can be cleaned for various materials, such as galvanised sheet, aluminium, copper, stainless steel, etc. Daily (according to 20H) can be cleaned 2-3T products to meet the requirements of the 36N or more Dainty test, can achieve 400μm cleanliness standards.<br />',
	    produceListTitleThirteen: 'CONTINUOUS HOT AIR TEMPERING FURNACE',
	    produceListTextThirteen01: '3 sets',
	    produceListTextThirteen02: 'Tonglu Sanli',
	    produceListTextThirteen03: '<br />Adopting up and down arrangement design, uniform heating temperature, long service life, low failure rate, can meet the requirements of product dyne test and lamp parts degassing test.',
	    produceListTitleFourteen: 'SEMI-AUTOMATIC <br /> RIVETING MACHINE',
	    produceListTextFourteen01: '4 sets',
	    produceListTextFourteen02: 'Shenzhen Nexus',
	    produceListTextFourteen03: '<br />High production efficiency, suitable for riveting all kinds of automotive bracket screws, nuts',
	    produceListTextFourteen04: '20,000 pieces/set',
	    produceListTitleFiveTeen: 'LASER CODING MACHINE',
	    produceListTextFiveteen01: '3 sets',
	    produceListTextFiveteen02: 'Guangzhou micro embedded',
	    produceListTextFiveteen03: '<br />Meet all kinds of stamping parts 2D code etching, to meet customer requirements for parts traceability',
	    produceListTextFiveteen04: '2 million pieces',
	    produceListTitleSixTeen: 'CCD VISUAL INSPECTION MACHINE',
	    produceListTextSixteen01: '5 sets',
	    produceListTextSixteen02: 'to achieve high efficiency, the appearance of the spring, riveted parts and dimensional control of automated inspection',
	    produceListTextSixteen03: '160,000 pieces/set',
	    produceListTitleSevenTeen: 'AIR TIGHTNESS INSPECTION MACHINE',
	    produceListTextSeventeen01: '2 sets',
	    produceListTextSeventeen02: 'high precision airtightness inspection, relatively high efficiency, to meet the needs of product airtightness inspection',
	    produceListTitleEightTeen: 'VIBRATION TESTING MACHINES',
	    produceListTextEightTeen01: '22 sets',
	    produceListTextEightTeen02: 'Highly efficient inspection of snap fasteners and springs.',
	    produceListTitleNineTeen: 'WIRE CUTTING MACHINES',
	    produceListTextNineTeen01: '4 sets',
	    produceListTextNineTeen02: 'imported western / Shadick brand',
	    produceListTextNineTeen03: 'Accuracy up to 0.002mm, good stability, processing range 500 * 300mm',
	    detectTitleZH: 'Testing Equipment',
	    detectTitleEN: '',
	    detectMainTitleOne: 'Testing Equipment - Springs',
	    detectMainTitleTwo: 'Testing Equipment - Hardware',
	    detectNum: 'Number of equipment：',
	    detectRange: 'Detection range：',
	    detectTitleOne: 'CLEANLINESS ANALYSER',
	    detectTextOne: 'With an independent class 100,000 dust-free testing room, equipped with German imported automatic particle extractor and high-precision automatic particle analysis instruments, can automatically determine the properties of the extracted material, can accurately and quickly detect the surface cleanliness of parts.',
	    detectTitleTwo: 'TENSILE AND COMPREHENSIVE FORCE MEASURING MACHINES',
	    detectTextTwo01: '7 sets of different ranges of tensile force measuring machine, 5 sets of Japanese imports',
	    detectTextTwo02: '0-10,000N range of tension spring force can be detected, of which the maximum range of high-precision tension force measuring machine for 10N, accuracy of 0.0001N, can be accurate and fast detection of the spring force',
	    detectTitleThree: 'TORQUE MEASURING MACHINE',
	    detectTextThree01: '4 sets',
	    detectTextThree02: 'Measuring torque range 0-100N.m, can be a variety of shapes, standard, non-standard, special spring torque implementation of accurate detection',
	    detectTitleFour: 'THIRD DIMENSION (MATH.)',
	    detectTextFour01: '2 sets',
	    detectTextFour02: 'can detect the contour and surface shape dimensions, angle and position detection and quality control of all kinds of complex workpieces, can be applied to the input of 3D moulds, will be finished moulds and moulds on the positioning, dimensions, related to the tolerance of the shape of the surface, curves, surfaces for measurement, the output of graphical reports, intuitive and clear response to the quality of the moulds.',
	    detectTitleFive: 'ONE-WAY VALVE AUTOMATIC FULL INSPECTION, PACKAGING',
	    detectTextFive: 'One-way valve project-specific CCD dimensional inspection and packaging automation equipment, can accurately and quickly carry out the dimensional inspection and complete packaging',
	    detectTitleSix: 'TAILGATE SPRING FORCE MEASURING MACHINE',
	    detectTextSix01: '3 sets',
	    detectTextSix02: ' customised special force measuring equipment, which can achieve the use of the spring state for going, return, average strength detection, and output curve report.',
	    detectTitleSeven: 'THIRD DIMENSION (MATH.)',
	    detectTextSeven01: '2 sets',
	    detectTextSeven02: 'Shirui three-dimensional',
	    detectTextSeven03: '800mm*1000mm*600mm, precision: (2.9+3.5L/1000)μm, can achieve the product and 3D model data comparison, to complete the structure of the complex product size measurement',
	    detectTitleEight: 'VIDEO MEASURING INSTRUMENTS',
	    detectTextEight01: '5 sets',
	    detectTextEight02: 'Aigoo brand',
	    detectTextEight03: '400mm*300mm, precision: (3+L/75)μm, can implement two-dimensional size measurement for small parts.',
	    detectTitleNine: 'HARDNESS TESTER',
	    detectTextNine01: '5 sets',
	    detectTextNine02: 'one each of YiGong and Era brand, with accuracy up to 0.1HV, can measure Rockwell and Vickers hardness of mould fittings and stamping metal parts.',
	    detectTitleTen: 'SPRING TENSION FORCE MEASURING MACHINE',
	    detectTextTen01: '2 sets',
	    detectTextTen02: 'AIKOH brand',
	    detectTextTen03: '0-450N, precision: 0.01N, the metal shrapnel products rapid elasticity test',
	    detectTitleEleven: 'PRODUCT-SPECIFIC FIXTURES',
	    detectTextEleven01: 'a number of',
	    detectTextEleven02: 'for the more complex products, the development of special inspection tools, to achieve rapid inspection and judgement',
	    environmentTitleZH: 'Workshop Environment',
	    environmentTitleEN: '',
	    environmentMainTitleOne: 'Workshop Environment — Springs',
	    environmentMainTitleTwo: 'Workshop Environment — Hardware',
	    environmentTextOne: 'Panoramic View Of The Workshop (I)',
	    environmentTextTwo: 'Panoramic View Of The Workshop (II)',
	    environmentTextThree: 'Seizure Zone',
	    environmentTextFour: '45T-160T Punch Press Area',
	    environmentTextFive: '200T-630T Punching Machine Area (I)',
	    environmentTextSix: '200T-630T Punching Machine Area (II)',
	    environmentTextSeven: 'Packing Area (I)',
	    environmentTextEight: 'Packing Area (II)',
	    environmentTextNine: 'Cleaning Machine',
	    environmentTextTen: 'Mould Storage Rack',
	    environmentTextEleven: 'Wire-Cutting Workshop (I)',
	    environmentTextTwelve: 'Wire-Cutting Workshop (II)',
	    environmentTextThirteen: 'Mould Making Area (I)',
	    environmentTextFourteen: 'Mould Making Area (II)',
	    environmentTextFifteen: 'Raw Materials Area',
	    environmentTextSixteen: 'Finished Product Area (I)',
	    environmentTextSeventeen: 'Finished Product Area (II)'
	  },
	
	  spring: {
	    breadcrumb: 'Current Location: Product > Spring Product Series >  ',
	    bannerTitleZH: 'SPRING SERIES',
	    bannerTitleEN: 'SPRING SERIES',
	    springTitleZH: 'Spring Series',
	    springTitleEN: '',
	    menulist01: 'Compression Spring Series',
	    menulist02: 'Tension Spring Series',
	    menulist03: 'Torsion Spring Series',
	    menulist04: 'Wire Forming Series',
	    menulist05: 'Scroll and shaped cross-section materials Spring Series',
	    phoneTitle: 'Service Customer Hotline:',
	    phoneNum: '+8620 8226 9286',
	    springTitleOne: 'Functions And Production Technology Characteristics',
	    springTitleTwo: 'Application Scenario',
	    springTextOne: 'Compression springs are a very versatile spring element that can be used in a variety of applications for motion control or vibration damping and energy storage. They are available in a wide range of materials, have a simple structure, can be smoothed on the end faces for force stability, can be shot peened on the surface to increase fatigue life, can be stored to meet the requirements for decay resistance, are cost-optimised by accurate spring stiffness and stress calculations, and have intelligent automated production controls to ensure that the quality requirements are met.',
	    springTextTwo: 'Compression springs are commonly used in the following applications: automotive shock absorber system springs, automotive clutch damping springs, automotive electric tailgate springs, springs for injection systems (pumps and injectors), shock absorbers, braking systems (ABS, ESP, brake actuators), transmission controls, belt and chain tensioning systems, oil pumps. Air conditioning compressor return springs, switch sensor springs, precision electronic sound sensor springs, etc.',
	    springTextThree: 'Extension springs are spring elements with a preloaded force that can be used as energy storage to control movement in a variety of applications, with complex hook structures (various wire-out hook types, helical hook types, card-board hook types, etc.), with F0 (initial tension) generated by the coils being tightened and predefined, and with materials that can be pre-zinc-plated or coated to achieve corrosion resistance, and CNC-molded to control the hook shape and initial tension with high precision.',
	    springTextFour: 'Extension springs are commonly used in the following applications: automotive relay return springs, automotive chassis cover return springs, automotive door lock springs, brake control system springs, automotive seat adjusting springs, automotive wiper tension springs, instrument balancer adjusting springs, door/window stabiliser springs, annular sealing ring springs and so on.',
	    springTextFive: 'Torsion springs are a very wide range of energy storage spring elements, can be used in a variety of application scenarios through the positive and negative torsion as energy storage to control the movement,, torsion arm structure is complex, the spring body is often supported by a mandrel, can be used at the same time more than one helical spring body can be accurately calculated stress and torque values, CNC intelligent automation of the production of dimensions with high precision, torque measurement, pay attention to the impact of friction.',
	    springTextSix: 'Torsion springs are commonly used in the following applications: automotive VVT return springs, automotive chassis cover latch springs, automotive door lock puller reset springs, brake control system springs, automotive seat adjustment springs, door hinge reset springs and so on.',
	    springTextSeven: 'Linear spring is a very wide range of mechanical motion control parts, through the CNC moulding can meet most of the requirements of the customer, at the same time can be spin forging shrinkage, rubbing teeth pattern, punching, punching, welding, overmoulding injection moulding and so on.',
	    springTextEight: 'Wire springs are commonly used in the following applications: automotive door lock levers, automotive steering wheel torsion bar springs, automotive wiper hook springs, seat backbone system springs, automotive seat headrest backbones, door hinge latches, and more.',
	    springTextNine: 'Coil and anisotropic section springs are special-purpose spring elements that can be used in a wide variety of applications as energy storage to control motion, friction stops, reset, etc. They are available in a wide variety of cross-sections (round, rectangular, steel strip, trapezoidal, elliptical, etc.), complex structures (torsion springs, planar volute springs, constant force springs, etc.), numerical simulations to find stress concentrations and calculate output force or torque through FEA design, local annealing to solve the risk of fracture caused by a small R-position, and professional scenarios designed to produce scientific fatigue evaluations, and a wide range of complex structures. A variety of complex structures can be moulded by CNC.',
	    springTextTen: 'Eddy coiled and anisotropic section springs are commonly used in the following applications: automotive engine VVT system return springs, automotive safety belt return springs, automotive door lock springs, timing belt and chain tensioning systems, automotive seat adjusting springs, medical device balancer adjusting springs, constant force springs for window and door stabilisers, washer drum non-slip springs, and so on.'
	  },
	
	  hardware: {
	    breadcrumb: 'Current Location: Product > Metal Hardware Series > ',
	    bannerTitleZH: 'METAL<br /> HARDWARE SERIES',
	    bannerTitleEN: 'METAL HARDWARE SERIES',
	    hardwareTitleZH: 'Metal Hardware Series',
	    hardwareTitleEN: '',
	    menulist01: 'Automotive Stamping Aluminium Parts Series',
	    menulist02: 'Structural Welding Rivet Series',
	    menulist03: 'Precision Stretching Machine Case Series',
	    menulist04: 'Elastic Snap Washer Series',
	    menulist05: 'Stainless Steel Precious Metal Series',
	    menulist06: 'Terminal And Other Series',
	    phoneTitle: 'Service Customer Hotline:',
	    phoneNum: '+8620 8226 9286',
	    hardwareTitleOne: 'Application Scenario',
	    hardwareTextOne: 'Lamp PCBA heat sink, ECU shield, internal control system PCBA heat sink bracket, control system aluminium cover, new energy battery shell, etc.',
	    hardwareTextTwo: 'Automotive electric control bracket, automotive lamp assembly mount, automotive interior bracket, automotive air conditioning bracket, automotive door lock bracket, etc.',
	    hardwareTextThree: 'Stainless steel drawing automobile water pump motor shield, automobile motor shell, automobile solenoid valve shell, automobile light bulb holder, etc.',
	    hardwareTextFour: 'Electric tailgate spring ball snap, engine plate, wiper pull spring, all kinds of car elastic washers, etc.',
	    hardwareTextFive: 'Hydrogen battery manifolds, automotive control PCBA shields, automotive starter motor precision counterweights, etc.',
	    hardwareTextSix: 'Automotive connector terminals, new energy battery terminals, tinned copper parts, etc.'
	  }
	};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var chinese = exports.chinese = {
	  homeView: {
	    menuList: {
	      index: '首页',
	      about: '关于我们',
	      products: '产品',
	      technology: '技术与设备',
	      contact: '联系我们',
	      synopsis: '奥图简介',
	      develop: '发展历程',
	      honor: '奥图荣耀',
	      team: '奥图团队',
	      spring: '弹簧产品系列',
	      hardware: '五金产品系列',
	      echnicalAdvantages: '技术优势',
	      productionEquipment: '生产设备',
	      inspectionEquipment: '检测设备',
	      workshopEnvironment: '车间环境'
	    }
	  },
	
	  footer: {
	    footerAbout: '关于我们',
	    footerProducts: '产品',
	    footerTechnology: '技术与设备',
	    footerContact: '联系我们',
	    footerSynopsis: '奥图简介',
	    footerDevelop: '发展历程',
	    footerHonor: '奥图荣耀',
	    footerTeam: '奥图团队',
	    footerSpring: '弹簧产品系列',
	    footerHardware: '五金产品系列',
	    footerEchnicalAdvantages: '技术优势',
	    footerProductionEquipment: '生产设备',
	    footerInspectionEquipment: '检测设备',
	    footerWorkshopEnvironment: '车间环境',
	    footerTel: '电话：( 86 ) 020-8226 9332',
	    footerFax: '传真：( 86 ) 20 - 8662 9332',
	    footerEmail: '邮箱：Info@autospring.cn',
	    footerAddress: '地址：广州经济技术开发区东区沧联小迳东路',
	    footerInfo: 'Copyright 2023-2028 autospring.cn | 奥图弹簧版权所有 | 粤ICP备14017194号-2'
	  },
	
	  indexPage: {
	    categoryNavigation: '分类导航 /',
	    classification: 'CLASSIFICATION',
	    springTitle: '弹簧产品系列',
	    springTitleEN: 'SPRING SERIES',
	    buttonText: '查看详情',
	    hardwareTitle: '五金产品系列',
	    hardwareTitleEN: 'METAL HARDWARE SERIES',
	    middleTitleOne: '规格多样',
	    middleTitleTwo: '诚信经营',
	    middleTitleThree: '加工定制',
	    middleTitleFour: '售后完善',
	    middleTitleFive: '货源充足',
	    middleSubTitleOne: 'DIVERSE STYLES',
	    middleSubTitleTwo: 'THE GOOD FAITH MANAGEMENT',
	    middleSubTitleThree: 'PROCESSING CUSTOMIZED',
	    middleSubTitleFour: 'PERFECT AFTER-SALES',
	    middleSubTitleFive: 'PLENTIFUL',
	    middleTextOneFir: '产品多种规格',
	    middleTextOneSec: '满足您的需求',
	    middleTextTwoFir: '诚信共赢、真材实料',
	    middleTextTwoSec: '责任担当、感恩奉献',
	    middleTextThreeFir: '支持加工定制',
	    middleTextThreeSec: '具体联系客服',
	    middleTextFourFir: ' 贴心服务',
	    middleTextFourSec: '放心购买',
	    middleTextFiveFir: '货源充足',
	    middleTextFiveSec: '满足大批量订购',
	    aboutTitleEN: 'ABOUT US',
	    aboutTitleZH: '关于我们',
	    aboutListOne: '1984年成立于香港',
	    aboutListTwo: '1998年独资成立广州奥图弹簧有限公司注册资本15000万( 港币 )，港资企业',
	    aboutListThree: '通过ISO9001、ISO14001、IATF16949',
	    aboutListFour: '提供出口、转厂、内销一站式服务模式',
	    aboutListFive: '占地面积25500m², 实用厂房面积24500m²',
	    aboutListSix: '拥有人员年平均700人, 两班生产',
	    aboutListSeven: '专业生产各类弹簧及五金冲压产品',
	    aboutListEight: '拥有弹簧设备330台及50多台级进模冲床',
	    aboutListNine: '年产弹簧23亿件, 冲压件2.1亿件',
	    aboutDetails: '查看详情',
	    aboutFooterTitleOne: '“ 起源于1984 ”',
	    aboutFooterTitleTwo: '“ 丰富的生产经验 ”',
	    aboutFooterTitleThree: '“ 强大生产能力 ”',
	    aboutFooterTitleFour: '“ 大型实体厂房 ”',
	    aobutFooterNumOne: '41',
	    aobutFooterNumTwo: '700',
	    aobutFooterNumThree: '23',
	    aobutFooterNumFour: '24500',
	    aboutFooterUnitOne: '年',
	    aboutFooterUnitTwo: '+名',
	    aboutFooterUnitThree: '+亿',
	    aboutFooterUnitFour: 'm²',
	    aboutFooterExplainOne: '行业经验',
	    aboutFooterExplainTwo: '生产人员',
	    aboutFooterExplainThree: '年产弹簧',
	    aboutFooterExplainFour: '厂房面积',
	    honorTitleZH: '荣誉证书 /',
	    honorTitleEN: 'CERTIFICATE OF HONOR',
	    customerTitleZH: '合作客户 /',
	    customerTitleEN: 'COOPERATIVE CUSTOMER'
	  },
	
	  about: {
	    breadcrumb: '当前位置： 关于我们  >  ',
	    aboutTitleZH: '关于我们',
	    aboutTitleEN: 'ABOUT US',
	    synopsis: '奥图简介',
	    develop: '发展历程',
	    honor: '奥图荣耀',
	    team: '奥图团队',
	    phoneTitle: '服务咨询热线：',
	    phoneNum: '020-8226 9332',
	    synTitleOneZH: '企业简介',
	    synTitleOneEN: 'Enterprise Introduction',
	    synTitleTwoZH: '企业理念',
	    synTitleTwoEN: 'Enterprise Philosophy',
	    synTitleTopOne: '弹簧工厂',
	    synTitleTopTwo: '五金工厂',
	    aboutListOne: '1984年成立于香港',
	    aboutListTwo: '1998年独资成立广州奥图弹簧有限公司注册资本15000万( 港币 )，港资企业',
	    aboutListThree: '通过ISO9001、ISO14001、IATF16949',
	    aboutListFour: '提供出口、转厂、内销一站式服务模式',
	    aboutListFive: '占地面积25500m², 实用厂房面积24500m²',
	    aboutListSix: '拥有人员年平均700人, 两班生产',
	    aboutListSeven: '专业生产各类弹簧及五金冲压产品',
	    aboutListEight: '拥有弹簧设备330台及50多台级进模冲床',
	    aboutListNine: '年产弹簧23亿件, 冲压件2.1亿件',
	    philosophyTitleTwo: '企业愿景',
	    philosophyTitleOne: '企业使命',
	    philosophyTitleThree: '企业价值观',
	    philosophyTitleFour: '质量方针',
	    philosophyTextTwo: '面向世界，实现工业智造，成就百年企业',
	    philosophyTextOne: '专业的产品与服务，让出行更安全，让生活更精彩',
	    philosophyTextThree: '专业，务实，创新，贡献',
	    philosophyTextFour: '品质至上，诚信务实，永攀新高，持续发展',
	    developmentTitleZH: '发展历程',
	    developmentTitleEN: 'Development Course',
	    developYearOne: '2019年至今',
	    developYearTwo: '2000年',
	    developYearThree: '1984年',
	    developYearFour: '2003年',
	    developYearFive: '1998年',
	    developInfoOneCom: '奥图弹簧五金分厂扩建 ( 宝丰分厂 )',
	    developInfoOneArea: '面积: 11000平方米',
	    developInfoFourCom: '广州奥图弹簧有限公司成立黄埔',
	    developInfoFourMain: '主营：精密弹簧、 五金冲压',
	    developInfoFourNum: '人员: 480',
	    developInfoFourArea: '面积: 13000平方米',
	    developInfoTwoCom: '深圳奥特图弹簧有限公司成立于深圳沙井',
	    developInfoTwoMain: '主营：精密弹簧',
	    developInfoTwoNum: '人员: 80',
	    developInfoTwoArea: '面积: 4000平方米',
	    developInfoFiveCom: '广州奥图弹簧有限公司成立广州东圃',
	    developInfoFiveMain: '主营：精密弹簧',
	    developInfoFiveNum: '人员: 80',
	    developInfoFiveArea: '面积: 3000平方米',
	    developInfoThreeCom: '公司成立于香港',
	    developInfoThreeMain: '主营：精密弹簧',
	    developInfoThreeNum: '人员: 30',
	    developInfoThreeArea: '面积: 1000平方米',
	    honorTitleZH: '奥图荣誉',
	    honorTitleEN: 'Auto Honor',
	    honorTitleOne: '研发技术中心',
	    honorTextOne: '公司已获得一系列的企业荣誉与资质认定。公司2014年已通过国家高新技术企业认定, 2015年通过广州市市级企业技术中心认定, 拥有广东省著名商标及广州市著名商标。 2017年认定为广东省技术中心。2024年被认定为专精特新“小巨人”企业。',
	    honorTitleTwo: '发明专利',
	    honorTextTwo: '公司推行改善文化，拥有六十多项发明专利。',
	    honorTitleThree: '体系证书',
	    honorTextThree: '公司已获得ISO9001:2015 、 ISO14001:2015、IATF16949:2016体系证书。',
	    honorTitleFour: '部分企业荣誉',
	    honorYearOne: '2011年',
	    honorYearTwo: '2013年',
	    honorYearThree: '2017年',
	    honorYearFour: '2018年',
	    honorYearFive: '2019年',
	    honorYearSix: '2022年',
	    honorYearSeven: '2023年',
	    honorYearEight: '2023年',
	    honorExplainOne: '荣获比亚迪汽车有限公司',
	    honorExplainOne02: '积极配合奖',
	    honorExplainTwo: '荣获歌尔声学股份有限公司',
	    honorExplainTwo02: '最佳竞争力奖',
	    honorExplainThree: '荣获柳州五菱汽车工业有限公司',
	    honorExplainThree02: '优秀供应商',
	    honorExplainFour: '荣获阿尔法(广州)汽车配件有限公司',
	    honorExplainFour02: '优秀供应商',
	    honorExplainFive: '荣获有信制造(中山)有限公司',
	    honorExplainFive02: '优秀供应商',
	    honorExplainSix: '荣获广东高壹工机有限公司',
	    honorExplainSix02: '优秀供应商',
	    honorExplainSeven: '荣获上海恩井汽车科技有限公司',
	    honorExplainSeven02: '优秀质量奖',
	    honorExplainEight: '荣获富临精工(芯智热控技术)有限公司',
	    honorExplainEight02: '技术贡献奖',
	    cultureTitleZH: '企业文化',
	    cultureTitleEN: 'Enterprise Culture',
	    cultureMainTextOne: '奥图经过几十载运营，深信优秀的企业文化乃做好百年基业之根本，坚持以人为本，诚信经营，高度重视企业文化的塑造，执行完善的管理体制、有效的人岗匹配性、透明的沟通氛围，及有洞察力和观察细微的全面评估体系。',
	    cultureMainTextTwo: '奥图文化民彩纷呈, 成立奥图工会, 每年开展多项活动: 如员工旅游、员工体检、篮球赛、拔河赛、桌球赛、6S知识竞赛、装拆模比赛等, 促使每位员工都充分发挥工作热情和创造力, 塑造出具有高度凝聚力和忠诚度的善于克难攻坚的高素质员工团队, 为企业发展提供源源不断的动力, 稳健提升企业优秀核心竞争力。',
	    cultureTitleOne: '企业文化 — 拓展活动',
	    cultureImgTitleOne: '启动大会',
	    cultureImgTitleTwo: '拔河比赛',
	    cultureImgTitleThree: '员工旅游',
	    cultureImgTitleFour: '拓展游戏',
	    cultureImgTitleFive: '户外拓展',
	    cultureImgTitleSix: '户外拓展',
	    cultureImgTitleSeven: '羽毛球比赛',
	    cultureImgTitleEight: '员工生日会',
	    cultureImgTitleNine: '一星班组',
	    cultureTitleTwo: '企业文化— 培训',
	    cultureTitleThree: '企业文化— 改善',
	    cultureTextOne: '公司每年开展大小型培训和沙盘活动累计参与人次2000人以上。',
	    cultureTextTwo: '公司不断改善创新: 每年改善提案约300个, 一周一改善约500个, 贯彻10大改善精神。',
	    cultureMationTitle: '十大改善精神',
	    cultureMationTextOne: '打破固有观念，敢于否定现状',
	    cultureMationTextTwo: '寻找可行的办法，不说『 不可能 』',
	    cultureMationTextThree: '不要辩解，迅速执行',
	    cultureMationTextFour: '不要求完美, 50分也好, 立即实施',
	    cultureMationTextFive: '错了马上改善',
	    cultureMationTextSix: '改善无极限',
	    cultureMationTextSeven: '遇到问题，首先想到是自己的责任',
	    cultureMationTextEight: '追求根源, 反复5次『 为什么 』',
	    cultureMationTextNine: '十个人的智慧，比一个人的智慧高明',
	    cultureMationTextTen: '先从不花钱的改善做起',
	    technicalTitleZH: '技术人员 ',
	    technicalTitleEN: 'Technical Personnel',
	    industryTitleZH: '行业地位 ',
	    industryTitleEN: 'Industry Position',
	    industryTextOne: '开发生产产品主要用于汽车，航空电器，高精密电路控制器，家用电器，办公用电子电脑，手机通讯，建筑五金，医疗器械等遍及全球所有工业产品领域使用的弹簧及精密冲压五金部件等30多项行业国际先进技术。',
	    industryTextTwo: '为博世，本田，通用电器，法雷奥，比亚迪，麦格纳，苹果，惠普，美芝压缩机，京西重工等国际知名客户提供一站式服务，并获得多项荣誉。先后与瑞典弹簧协会Lesjofors集团，德国Spring Tec Group集团，华南金属研究所，中钢集团郑州金属制品研究院，贵州钢绳股份技术中心，进行科研生产联合体。',
	    industryTextThree: '同时注重引进、培养各类专业技术人才，建立起高素质的科研开发队伍，产品属于高科技精密零件，生产工艺高度自动化、技术处于国内领先水平，年产销量均居国内前茅，产品质量达到国内外同类先进或领先水平。',
	    domesticTitleZH: '国内地位',
	    domesticTitleEN: 'Domestic Status',
	    domesticTextOne: '奥图是国内生产规模线径范围最广（0.03-16mm）、产能规模最大、同时也可以配套生产五金冲压产品及零部件、技术实力雄厚、客户产品涵盖最广的生产企业之一；多次参与修订新的弹簧用碳素钢丝的标准，参与国家技术标准化的合作单位。',
	    domesticTextTwo: '公司技术研发中心依靠自身多年探索，克服国内外技术障碍，参与客户设计开发了多项弹簧和五金类产品，申请了60多项专利，并填补同类产品的国内空白，如双线同时卷制弹簧的工艺及产品、超精细塔型安全位弹簧、自动尾门弹簧、VVT项目的成功研发结束了必须依靠进口德系和意系的垄断，降低客户成本并能快速响应客户需求。',
	    strategicTitleZH: '战略规划',
	    strategicTitleEN: 'Strategic Planning',
	    strategicText: '得益于中国在全球市场的持续发展壮大，我们紧贴市场脉搏，坚持自主研发，不断创新，40多年来，不断精益求精，战胜一次一次的技术难关及市场的挑战，赢得了国内外客户的高度认可，未来，公司的主要市场竞争会更加激烈，我们将持续深化耕耘以下主营业务。',
	    objectiveTitleZH: '战略目标',
	    objectiveTitleEN: 'Strategic Objective',
	    objectiveTextOne: '2025年 营收预计8.45亿',
	    objectiveTextTwo: '2024年 营收预计6.50亿',
	    objectiveTextThree: '2023年 营收预计5.00亿'
	  },
	
	  contact: {
	    bannerTitleOne: '一切从',
	    bannerTitleTwo: '聆听',
	    bannerTitleThree: '开始',
	    bannerText: '把您的需求告诉我们，让我们优秀的团队为您服务!',
	    breadcrumb: '当前位置： 联系我们',
	    contactTitleZH: '联系我们',
	    contactTitleEN: 'Contact Us',
	    compNameZH: '广州奥图弹簧有限公司',
	    compNameEN: 'GUANGZHOU AUTO SPRING CO.,LTD.',
	    compAdd: '地址：广东省广州市黄埔区小迳东路',
	    compTel: '电话：( 86 ) 020-8226 9332',
	    compFax: '传真：( 86 ) 20-8226 9339',
	    compZip: '邮编：510760',
	    compEmail: '邮箱：Info@autospring.cn',
	    compWeb: '网址：www.autospring.cn',
	    phoneTitleZH: '咨询热线：',
	    phoneNum: '+86 020-8226 9332'
	  },
	
	  technology: {
	    bannerTitleOne: '您的满意',
	    bannerTitleTwo: '就是我们专业的表达',
	    bannerTitleThree: '几十载的行业经验，出彩专业经验与执行能力',
	    bannerTitleFour: '成功服务上万家客户',
	    breadcrumb: '当前位置： 技术与设备  >  ',
	    technologyTitleZH: '技术与设备',
	    technologyTitleEN: 'Technology and equipment',
	    advantage: '技术优势',
	    produce: '生产设备',
	    detect: '检测设备',
	    environment: '车间环境',
	    phoneTitle: '服务咨询热线：',
	    phoneNum: '020-8226 9332',
	    advantageTitleZH: '技术优势',
	    advantageTitleEN: 'Technology And Equipment',
	    advantageMainTitleOne: '技术优势 — 弹簧篇',
	    advantageMainTitleTwo: '技术优势 — 五金篇',
	    listTitleOne: '强大的工艺及设备开发能力',
	    listTextOne: '公司技术研发中心依靠自身多年探索，克服国内外技术障碍，参与客户设计开发了多项弹簧和五金类产品，申请了60多项专利，并填补同类产品的国内空白，如双线同时卷制弹簧的工艺及产品、超精细塔型安全位弹簧、自动尾门弹簧、VVT项目的成功研发结束了必须依靠进口德系和意系的垄断，降低客户成本并能快速响应客户需求。',
	    listTitleTwo: '全面专业的试验检测能力',
	    listTextTwo: '拥有各种先进的全自动高精密的力学测量设备20多台，最小读值0.001N，光学影像及3D测量10多台，各类环境及恒温恒湿测试多台，能够对材料及产品力学，空间尺寸，材料特性及金相组织结构，表面耐蚀性，不同温度的耐松弛性，疲劳特性，清洁度等提供全面专业的技术质量报告。同时公司还开发应用了大量的在线检测技术。',
	    listTitleThree: '专业的研发团队',
	    listTextThree: '公司拥有30多名丰富经验的金属材料，自动化控制专业技术研发骨干，依客户设计概念或使用工况，基于有限元通过CAE分析，提供专业的弹簧结构，应力验算，疲劳分析等设计建议，让设计变得更合理更安全。专业团队对设备功能扩展，增加防错预警及安全装置；自行开发专用设备及特种工装。',
	    listTitleFour: '专业的工装模具制作',
	    listTextFour: '“中国智造”不仅仅体现自动化和智能化，还必须确保制程能力稳定性为前提，这就需要我们的丰富经验的PE人员专业的设计及高精度的各类CNC模治具加工设备为保障。',
	    listTitleFive: '丰富的产品生产线',
	    listTextFive: '我们拥有300多台各类型号的CNC弹簧加工设备和50多台（16-300T）级进模冲床及模具加工设备，线径覆盖0.03mm-16mm，板材厚度0.05-5mm，可以加工钢，铁，铝，稀有合金，不锈钢，铜及其合金等，为客户提供各种高效专业的解决方案。',
	    listTitleSix: '丰富的表面处理技术',
	    listTextSix: '低温渗氮，MAGNI，植绒，改性粉末有机复合涂层，镀厚金等。提高防腐蚀，耐摩擦，降低噪声同时又延长疲劳效果。',
	    listTitleSeven: '专业的工程技术团队',
	    listTextSeven01: '★  技术团队熟悉IATF16949体系',
	    listTextSeven02: '★  熟悉系统化新产品开发流程及客户系统',
	    listTextSeven03: '★  对材料选用、合理工艺规划具有丰富经验',
	    listTextSeven04: '★  CAE分析能力、配合客户研发的经验',
	    listTextSeven05: '★  汽车、精密电子类模具设计制作丰富经验',
	    listTextSeven06: '★  产品开发过程问题对策与解决的丰富经验',
	    listTitleEight01: '强大的专用制造',
	    listTitleEight02: '用工装、设备开发能力',
	    listTextEight01: '★  专用零件组装设备的开发能力',
	    listTextEight02: '★  专用冲床周边辅助设备开发能力',
	    listTextEight03: '★  专用后工序检查工装、设备开发能力等',
	    listTitleNine01: '强大的专用检测',
	    listTitleNine02: '用工装、设备开发能力',
	    listTextNine01: '★  CCD全检设备开发能力',
	    listTextNine02: '★  专用气密性检测设备开发能力',
	    listTextNine03: '★  专用检测治具开发能力',
	    listTextNine04: '★  其它专用试验设备开发能力等',
	    listTitleTen01: '各类型冲压模具的',
	    listTitleTen02: '开发经验',
	    listTextTen01: '★  16-630T及以下连续模开发',
	    listTextTen02: '★  16-630T及以下机械手传送模开发',
	    listTextTen03: '★  高精度拉伸连续、传送模开发',
	    listTextTen04: '★  材料厚度0.1~6MM区间模具开发',
	    listTitleEle: '广泛的材料适配能力',
	    listTextEle01: '★  丰富的工艺规划经验及结构设计能力',
	    listTextEle02: '★  精密的加工、制造设备',
	    listTextEle03: '★  强大的供应链体系',
	    listTextEle04: '★  满足各类铝铜、合金，0.1~6MM厚度的不锈钢、高强板、拉伸材料等的冲压加工',
	    listTitleTwe: '涵盖面广，种类多样的产品线',
	    listTextTwe01: '★  16-630T区间50余台设备的连续冲压制造能力',
	    listTextTwe02: '★  配套的模具制造能力',
	    listTextTwe03: '★  配套的专用工装制造能',
	    listTextTwe04: '★  配套的清洗除油能力',
	    listTextTwe05: '★  配套的产线后处理能力',
	    listTitleThi: '强有力的供应商整合能力',
	    listTextThi01: '★  各关键岗位负责人熟悉行业状况',
	    listTextThi02: '★  采购大数据管理系统的支持',
	    listTextThi03: '★  强大的供应商优选、评价、管理体系',
	    listTextThi04: '★  充分利用行业资源的能力',
	    listTextThi05: '★  先人一步的快速反应能力',
	    produceTitleZH: '生产设备',
	    produceTitleEN: 'Production Equipment',
	    produceMainTitleOne: '生产设备 — 弹簧篇',
	    produceMainTitleTwo: '生产设备 — 五金篇',
	    produceTitleNum: '设备数量：',
	    produceTitleSpecialty: '设备特长：',
	    produceTitleMain: '主攻产品：',
	    produceTitleDay: '日产量：',
	    produceTitleMonth: '月产量：',
	    produceTitleYear: '年产量：',
	    produceListTitleOne: '弹簧自动立定设备',
	    produceListTextOne: '面临人力成本居高临下，以往依靠人员手工作业，通过自主研发设备，产品通过自动生产线完成工序要求，提高生产效率和降低制造成本',
	    produceListTitleTwo: '全自动多功能折角机',
	    produceListTextTwo: '针对汽车门锁拉杆类产品进行自主研发专用的折角设备，效率提高50%',
	    produceListTitleThree: '全自动旋锻机',
	    produceListTextThree: '针对汽车门锁拉杆类产品进行自主研发专用的旋锻设备，打破原有旋锻设备的加工方式思维，效率提高50%；专门成立6条生产线生产拉杆类产品',
	    produceListTitleFour: '台湾精密压簧机',
	    produceListTextFour01: '60台',
	    produceListTextFour02: '设备精度高，生产产品稳定性高，产品外经最小公差可控制在0.01mm,长度公差可控制0.02mm；每台机配置自动检长机，生产过程自动监控产品的长度，长度出现偏离可进行自动修复，超出公差范围自动分离功能，有效的保证产品质量',
	    produceListTextFour03: 'φ0.1以上的压力弹簧',
	    produceListTextFour04: '5000万PCS',
	    produceListTitleFive: '台湾7轴大压簧机',
	    produceListTextFive01: '5台',
	    produceListTextFive02: '7轴单独操作；换型简便；效率高',
	    produceListTextFive03: 'φ3.0以上的各种大压簧。目前主要生产汽车离合器、发动机、汽车尾门类型产品',
	    produceListTextFive04: '450万PCS',
	    produceListTitleSix: '台湾精密拉簧机',
	    produceListTextSix01: '15台',
	    produceListTextSix02: '设备精度高，生产拉簧类产品稳定性高',
	    produceListTextSix03: '普通德式、英式拉簧，产品主要应用在电子电器、开关等等，可生产范围φ0.1mm-φ0.8mm线径的拉力弹簧',
	    produceListTextSix04: '500万PCS',
	    produceListTitleSeven: '日本MEC多功能弹簧机',
	    produceListTextSeven01: '多台',
	    produceListTextSeven02: '专生产0.03mm-0.3mm线径范围的各类型小产品，主要应用在精密电子或者医疗产品上',
	    produceListTextSeven03: '2000万PCS',
	    produceListTitleEight: '12轴多功能弹簧机',
	    produceListTextEight01: '12轴分别为单独伺服电机控制，转换产品型号高效，节省人员排凸轮的时间，生产0.3mm-2.0mm线径范围的各类型产品，主要生产异形的拉簧、扭簧、线成型类产品',
	    produceListTextEight02: '5000万PCS',
	    produceListTitleNine: '12轴大型多功能弹簧机',
	    produceListTextNine01: '多台',
	    produceListTextNine02: '12轴单独操作；换型简便；效率高',
	    produceListTextNine03: 'φ3.0以上的各种扭簧、拉簧、线成型',
	    produceListTextNine04: '450万PCS',
	    produceListTitleTen: '45T-630T连续冲床',
	    produceListTextTen01: '50台',
	    produceListTextTen02: '金丰/东泰/广锻',
	    produceListTextTen03: '精密冲床、性能稳定，可生产材料厚度0.1mm-6.0mm各种材质的精密五金冲压产品及机壳等拉伸产品',
	    produceListTitleEleven: '10T-38T精密成型机(扣机)',
	    produceListTextEleven01: '9台',
	    produceListTextEleven02: '台湾逸昇',
	    produceListTextEleven03: '适用于直径0.1mm-5.0mm的镀锌线、不锈钢等材质的线成型各式球簧、卡簧产品生产',
	    produceListTitleTwelve: '全自动碳氢清洗机',
	    produceListTextTwelve01: '2套',
	    produceListTextTwelve02: '可对各材质产品进行清洗，如镀锌板、铝、铜、不锈钢等 每日（按20H）可清洗2-3T产品，满足36N以上达因测试要求,能达到400μm清洁度标准',
	    produceListTitleThirteen: '连续式热风回火炉',
	    produceListTextThirteen01: '3台',
	    produceListTextThirteen02: '桐庐三立',
	    produceListTextThirteen03: '采用上下排列设计，加热温度均匀，使用寿命长，故障率低，可满足产品达因测试及车灯零件脱气测试要求',
	    produceListTitleFourteen: '半自动压铆机',
	    produceListTextFourteen01: '4台',
	    produceListTextFourteen02: '深圳耐克斯',
	    produceListTextFourteen03: '生产效率高，适用于铆接各式汽车支架螺钉、螺帽',
	    produceListTextFourteen04: '2万件/套',
	    produceListTitleFiveTeen: '激光打码机',
	    produceListTextFiveteen01: '3台',
	    produceListTextFiveteen02: '广州微嵌',
	    produceListTextFiveteen03: '满足各类冲压件二维码蚀刻，满足客户对零件可追溯要求',
	    produceListTextFiveteen04: '200万件',
	    produceListTitleSixTeen: 'CCD视觉检测机',
	    produceListTextSixteen01: '5台',
	    produceListTextSixteen02: '实现高效率,对卡簧、铆接件外观及尺寸控制自动化检查',
	    produceListTextSixteen03: '16万件/台',
	    produceListTitleSevenTeen: '气密性检查机',
	    produceListTextSeventeen01: '2台',
	    produceListTextSeventeen02: '气密性检查精密度高，效率相对较高，满足产品气密性检查需求',
	    produceListTitleEightTeen: '振动检测机',
	    produceListTextEightTeen01: '22台',
	    produceListTextEightTeen02: '高效率实现卡扣卡簧类产品,开口尺寸检查',
	    produceListTitleNineTeen: '慢走丝线割机床',
	    produceListTextNineTeen01: '4台',
	    produceListTextNineTeen02: '进口西部/沙迪克品牌',
	    produceListTextNineTeen03: '精度可达0.002mm，稳定性好，加工范围500*300mm,开口尺寸检查',
	    detectTitleZH: '检测设备',
	    detectTitleEN: 'Testing Equipment',
	    detectMainTitleOne: '检测设备 — 弹簧篇',
	    detectMainTitleTwo: '检测设备 — 五金篇',
	    detectNum: '设备数量：',
	    detectBrand: '设备品牌：',
	    defaultBrand: '国产',
	    detectRange: '检测范围：',
	    detectTitleOne: '清洁度分析仪',
	    detectBrandOne: '德国 JOMESA HFD4',
	    detectTextOne: '拥有独立的10万级无尘检测室，配备德国进口自动颗粒萃取机与高精度自动颗粒分析仪器，能自动判定萃取物属性，可精准、快速检测零件表面清洁度',
	    detectTitleTwo: '拉、压测力机',
	    detectBrandTwo: '日本 DigiTech',
	    detectTextTwo01: '7台不同量程拉压测力机，5台为日本进口',
	    detectTextTwo02: '可检测0-10000N范围的拉压弹簧力度，其中高精度拉压测力机最大量程为10N,精度可达到0.0001N,能精准、快速检测弹簧力度',
	    detectTitleThree: '扭力测力机',
	    detectBrandThree: '日本 JISC PRO',
	    detectTextThree01: '4台',
	    detectTextThree02: '测量扭矩范围0-100N.m，可对各种形状，标准、非标准、特殊弹簧的扭矩实施精准检测',
	    detectTitleFour: '三次元',
	    detectBrandFour: '海克斯康',
	    detectTextFour01: '2台',
	    detectTextFour02: '可检测各种形状复杂工件的轮廓和表面形状尺寸，角度和位置检测与质量控制，可以应用3D数模的输入，将成品模具与数模上的定位，尺寸，相干的形位公差，曲线、曲面进行测量，输出图形化报告，直观清楚的反应模具质量',
	    detectTitleFive: '单向阀自动全检、包装',
	    detectBrandFive: '惠州中科院',
	    detectTextFive: '单向阀项目专用CCD尺寸全检与包装自动化一体设备，能精准、快速进行尺寸全检并完成包装',
	    detectTitleSix: '尾门弹簧测力机',
	    detectBrandSix: '东莞艾顿',
	    detectTextSix01: '3台',
	    detectTextSix02: '为定制专项测力设备，可实现弹簧使用状态进行去程、回程、平均值力度检测，并输出曲线报告',
	    detectTitleSeven: '三次元',
	    detectBrandSeven: '海克斯康',
	    detectTextSeven01: '2台',
	    detectTextSeven02: '思瑞三次元',
	    detectTextSeven03: '800mm*1000mm*600mm，精度:(2.9+3.5L/1000)μm,可实现产品与3D数模数据对比，完成结构复杂产品尺寸测量',
	    detectTitleEight: '视频测量仪',
	    detectBrandEight: '东莞艾顿',
	    detectTextEight01: '5台',
	    detectTextEight02: '艾顾品牌',
	    detectTextEight03: '400mm*300mm，精度:(3+L/75)μm,可对细小零件实施二维尺寸测量',
	    detectTitleNine: '硬度测试仪',
	    detectBrandNine: '北京时代之峰、依工',
	    detectTextNine01: '5台',
	    detectTextNine02: '精度可达0.1HV,可对模具配件、冲压金属零件进行洛氏和维氏硬度测量',
	    detectTitleTen: '弹簧拉压测力机',
	    detectBrandTen: '日本 AIKOH',
	    detectTextTen01: '2台',
	    detectTextTen02: 'AIKOH品牌',
	    detectTextTen03: '0-450N，精度:0.01N,对金属弹片类产品快速进行弹力测试',
	    detectTitleEleven: '产品专用检具',
	    detectBrandEleven: '奥图自制',
	    detectTextEleven01: '若干',
	    detectTextEleven02: '针对较复杂的产品,开发专用检具,实现快速检验与判定',
	    environmentTitleZH: '车间环境',
	    environmentTitleEN: 'Workshop Environment',
	    environmentMainTitleOne: '车间环境 — 弹簧篇',
	    environmentMainTitleTwo: '车间环境 — 五金篇',
	    environmentTextOne: '车间全景（ 一 ）',
	    environmentTextTwo: '车间全景（ 二 ）',
	    environmentTextThree: '扣机区',
	    environmentTextFour: '45T-160T冲床区域',
	    environmentTextFive: '200T-630T冲床区域（ 一 ）',
	    environmentTextSix: '200T-630T冲床区域（ 二 ）',
	    environmentTextSeven: '包装区（ 一 ）',
	    environmentTextEight: '包装区（ 二 ）',
	    environmentTextNine: '清洗机',
	    environmentTextTen: '模具存放架',
	    environmentTextEleven: '线切割车间（ 一 ）',
	    environmentTextTwelve: '线切割车间（ 二 ）',
	    environmentTextThirteen: '模具制作区（ 一 ）',
	    environmentTextFourteen: '模具制作区（ 二 ）',
	    environmentTextFifteen: '原材料区',
	    environmentTextSixteen: '成品区（ 一 ）',
	    environmentTextSeventeen: '成品区（ 二 ）'
	  },
	
	  spring: {
	    breadcrumb: '当前位置： 产品  >  弹簧产品系列  >  ',
	    bannerTitleZH: '弹簧产品系列',
	    bannerTitleEN: 'SPRING PRODUCT SERIES',
	    springTitleZH: '弹簧产品系列',
	    springTitleEN: 'SPRING PRODUCT SERIES',
	    menulist01: '压簧系列',
	    menulist02: '拉簧系列',
	    menulist03: '扭簧系列',
	    menulist04: '线成型系列',
	    menulist05: '涡卷及异型截面材料弹簧系列',
	    phoneTitle: '服务咨询热线：',
	    phoneNum: '020-8226 9332',
	    springTitleOne: '功能及生产技术特点',
	    springTitleTwo: '应用场景',
	    springTextOne: '压缩弹簧是一种用途非常广泛弹簧元件，能够在多种应用场景中用作控制运动或减震储能。材料丰富，结构简单，端面可以磨平有利于受力稳定，表面可抛丸增加疲劳寿命，可以储存应力满足耐衰减性能要求，精准的弹簧刚度及应力计算使成本更加优化，智能自动化生产控制确保质量要求得以满足。',
	    springTextTwo: '压缩弹簧常用于以下应用：汽车避震系统弹簧，汽车离合器阻尼弹簧，汽车电动尾门弹簧，喷射系统（泵和喷油器）弹簧、减震器、制动系统（ABS、ESP、制动执行器）、变速箱控制、皮带和链条张紧系统、油泵。空调压缩机回位弹簧，开关传感器弹簧，精密电子声音传感器弹簧等。',
	    springTextThree: '拉伸弹簧是一种带有预紧力的弹簧元件，能够在多种应用场景中用作储能控制运动，钩位结构复杂（有各种线出拉钩型，螺旋拉钩型，卡板拉钩型等），通过弹簧圈并紧预变形产生F0（初拉力），材料可以预镀锌或其他镀层达到防腐蚀性能，CNC成型能高精度控制钩位形状及初拉力。',
	    springTextFour: '拉伸弹簧常用于以下应用：汽车继电器回位弹簧，汽车机箱盖回位弹簧，汽车门锁弹簧，刹车控制系统弹簧、汽车座椅调节弹簧，汽车雨刮器拉簧，器械平衡器调节弹簧，门窗稳定器弹簧，环形密封圈弹簧等。',
	    springTextFive: '扭转弹簧是一种非常广泛的储能弹簧元件，能够在多种应用场景中通过正反扭转用作储能控制运动，，扭臂结构复杂，簧体常有芯轴支撑，可同时多个螺旋簧体使用，可精确计算应力及扭矩值，CNC智能自动化生产尺寸精度高，扭矩测量时注意摩擦力影响。',
	    springTextSix: '扭转弹簧常用于以下应用：汽车VVT回位弹簧，汽车机箱盖锁扣弹簧，汽车门锁拉手复位弹簧，刹车控制系统弹簧、汽车座椅调节弹簧，门铰链复位弹簧等。',
	    springTextSeven: '线型弹簧是一种非常广泛的机械运动控制零件，通过CNC成型能够满足客户绝大部分要求，同时可旋锻缩径，搓牙纹，冲扁，冲孔，焊接，包胶注塑等。',
	    springTextEight: '线型弹簧常用于以下应用：汽车门锁拉杆，汽车方向机扭杆弹簧，汽车雨刮器拉钩弹簧，座椅骨架系统弹簧、汽车座椅头枕骨架，门铰链锁扣等。',
	    springTextNine: '渦卷及异性截面弹簧是一种特殊用途的弹簧元件，能够在多种应用场景中用作储能控制运动，摩擦止滑，复位等。材料截面多样（有圆截面，矩形截面，钢带，梯形，椭圆截面等），结构复杂（有扭簧型，平面渦卷型，恒力弹簧型等），通过FEA设计可数值模拟发现应力集中点并计算输出力值或扭矩，可以局部退火解决R位过小带来的断裂风险，专业的场景测试设计得出科学的疲劳评估，多种复杂的结构都可通过CNC成型。',
	    springTextTen: '渦卷及异性截面弹簧常用于以下应用：汽车发动机VVT系统回位弹簧，汽车安全带回位弹簧，汽车门锁弹簧，正时皮带和链条张紧系统、汽车座椅调节弹簧，医疗器械平衡器调节弹簧，门窗稳定器恒力弹簧，洗衣机滚筒止滑弹簧等。'
	  },
	
	  hardware: {
	    breadcrumb: '当前位置： 产品  >  五金产品系列  >  ',
	    bannerTitleZH: '五金产品系列',
	    bannerTitleEN: 'HARWARE PRODUCT SERIES',
	    hardwareTitleZH: '弹簧产品系列',
	    hardwareTitleEN: 'HARWARE PRODUCT SERIES',
	    menulist01: '汽车冲压铝件系列',
	    menulist02: '结构件焊铆件系列',
	    menulist03: '精密拉伸机壳系列',
	    menulist04: '弹性卡扣垫圈系列',
	    menulist05: '不锈钢贵金属系列',
	    menulist06: '端子类及其它系列',
	    phoneTitle: '服务咨询热线：',
	    phoneNum: '020-8226 9332',
	    hardwareTitleOne: '应用场景',
	    hardwareTextOne: '车灯PCBA散热片,ECU屏蔽罩,内控系统PCBA散热支架,控制系统铝盖,新能源电池壳等',
	    hardwareTextTwo: '汽车电控支架,汽车车灯装配固定座,汽车内饰支架,汽车空调支架,汽车门锁支架等',
	    hardwareTextThree: '不锈钢拉伸汽车水泵电机屏蔽罩,汽车电机外壳,汽车电磁阀壳,汽车灯泡座等',
	    hardwareTextFour: '电动尾门弹簧球头卡扣,发动机片,雨刮拉簧,汽车各类弹性垫圈等',
	    hardwareTextFive: '氢能源电池集流板,汽车控制PCBA屏蔽罩,汽车启动电机精密配重块等',
	    hardwareTextSix: '汽车连接器端子,新能源电池端子,镀锡铜件等'
	  }
	};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAfCAYAAABEZosIAAAAAXNSR0IArs4c6QAABFZJREFUaEPFmlmoVmUUhh8rG22wgsSyaCJKkgaoi7S68EIoIpqQoESoqNTmkcrMJjUzm7S5O8WCJiMaLhqgiyKiGekmyMg0tJnMzOKB9cPv6R/2t/69j+vqcM631re+d397rfdd+4xgeG0McClwcGz7b8XttwP+AT4GngV+r+g38LIRA0eoHmBv4HrgYmBUIUAuF6S1wN0B0qbqW+dXDhdAAnItcF0bONmsfwyglwF/Z4NU9RsOgHYBLgPmALtXTazPutXA1cDLwOaaYnYM0zRAOwLTgNuB/Ws+yGfADcAbNcfdKlyTAO0ATAXuBQ5o6BCfAFcC7zUUn6YA2h44DXgAOKSp5CPuB8Dl0eFq36opgE4NcI6pPePOAV+PmrSq7v2aAOhE4FHg+MJk5Tl/ABb1kYW+W4CVAdI3hb49l9cN0IQAZ2Iiye+ApcA44Hxgj0SM5cCNgF2uFqsToCOAhcDpicx+BRbEaykVeBA4N8hhSTjJ4zNBKSSVA1tdAB0E3AecBVigS0we8wRwB7AuHI8GHgFOLgkUa3+LeHcBPyf8t3KpA6D9opXLd5QDJWbteAmYCawZ4nhSHPSokoCx9s+4zd5ob2faBgVoX2A2cAmwUyKLd4EZwJddfM8EFrWJ25ItvD3zoiamxe0gAFkrLIizkgXVlqwEeafHqQVdcXsnsFcJOrH2+/B9OqvbsgApPq8Abk6KTwuor9WLMcbodXa7mVMAhe7OCZCsa9cAKzK6LQPQrsBFoa8cYZSaanwu8HjBU3Wf+aHrSjmS+cmNBLlY3JYCZIe6IA4oXym1jdHC1We/FDofCDwMnFHo11r+Rdykt0r8SwASnLODq4wt2STWOj10huNcKMtRZOdPAscm9tfl02gK71f1rwqQ4EwB7gckhBl7O8atX2ecw8d8JaJKmcwNNozgWJM+rJJHVYBOCXBK9VUrh8+jY1V+cj2S92G1Ops0o9S8yW8GSF/1c64C0HGhkU7oF6zL3+Ujcp3nMl2kS0wbhfzLqaJDuVKToL4aFOXbXs79AJLyPwQ4vsiYBO0eYDEgu63TrIPOm84bIKji9iagK0i9ADos6Lpdox+QnXJUOErQbgU2DHCIXq5HAo8lNZtx/4ovJOrAHzpt1O3gjkhV1+ckZjPu43v+WtSKoRqrbqysj3a2w5OBnUEJckdx2wkgh+sO2acDzpUzZlG2kDoObdoUyBfGbd8nuZkgKWwds/zUHmMoQG6gfPDr527JzRxWqc9eiZuUDFPkpvSxdasNLeAZWx9vzZL2L7ftABnYzyhXAXtmdgj07S4lMiK51f/cFLPeAm9TRo4YUN3m2/NUq+O2AFIQqqxvGeDjnjJC9AXIK7st7NCgJJOTjcWcnQD4FklLNgrQ6BCf/tKfM+bA/YW44rUOzRPJTAqQxid8Wy7Ox28DnhcgiaCvll3A1uxhS9q6MxsDejXVOtvazMfRr0M8a1PpPznI1CWfH1mT/gOMJsZPOJc03wAAAABJRU5ErkJggg=="

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _zh = __webpack_require__(3);
	
	var _en = __webpack_require__(2);
	
	exports.default = (0, _vue.defineComponent)({
	  setup: function setup() {
	    var copyData = (0, _vue.ref)({});
	
	    var getLanguage = function getLanguage() {
	      copyData.value = _zh.chinese;
	    };
	
	    var windowWidth = (0, _vue.ref)(document.body.clientWidth);
	
	    var menuTag = (0, _vue.ref)(0);
	
	    getLanguage();
	
	    return {
	      chinese: _zh.chinese,
	      english: _en.english,
	      copyData: copyData,
	      getLanguage: getLanguage,
	      windowWidth: windowWidth,
	      menuTag: menuTag
	    };
	  }
	});

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _zh = __webpack_require__(3);
	
	var _en = __webpack_require__(2);
	
	exports.default = (0, _vue.defineComponent)({
	  setup: function setup() {
	    var menuType = (0, _vue.ref)(0);
	    var getHref = function getHref() {
	      var href = window.location.href;
	      if (href.indexOf('index') != -1) {
	        menuType.value = 1;
	      } else if (href.indexOf('about') != -1) {
	        menuType.value = 2;
	      } else if (href.indexOf('product') != -1) {
	        menuType.value = 3;
	      } else if (href.indexOf('technology') != -1) {
	        menuType.value = 4;
	      } else if (href.indexOf('contact') != -1) {
	        menuType.value = 5;
	      }
	    };
	
	    var copyData = (0, _vue.ref)({});
	
	    var getLanguage = function getLanguage() {
	      copyData.value = _zh.chinese;
	    };
	
	    var tabTag = (0, _vue.ref)(0);
	    var mouseOver = function mouseOver(val) {
	      tabTag.value = val;
	    };
	    var mouseLeave = function mouseLeave() {
	      tabTag.value = 0;
	    };
	
	    var windowWidth = (0, _vue.ref)(document.body.clientWidth);
	
	    var maskTag = (0, _vue.ref)(false);
	    var menuListTag = (0, _vue.ref)(0);
	
	    getLanguage();
	    getHref();
	
	    return {
	      chinese: _zh.chinese,
	      english: _en.english,
	      menuType: menuType,
	      getHref: getHref,
	      getLanguage: getLanguage,
	
	      copyData: copyData,
	      tabTag: tabTag,
	      mouseOver: mouseOver,
	      mouseLeave: mouseLeave,
	      windowWidth: windowWidth,
	      maskTag: maskTag,
	      menuListTag: menuListTag
	    };
	  }
	});

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(12)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(18)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0fa8cf27"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(11)
	
	/* script */
	__vue_exports__ = __webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(17)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0ac04a32"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.windowWidth >= 800) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "menuCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./index.html"
	    }
	  }, [_c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 1 ? 'menuListAct' : ''
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.index))])])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 2 ? 'menuListAct' : '',
	    on: {
	      "mouseenter": function($event) {
	        return _vm.mouseOver(1)
	      },
	      "mouseleave": function($event) {
	        return _vm.mouseLeave()
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.about))]), _vm._v(" "), _c('ul', {
	    staticClass: "menuListCon",
	    class: _vm.tabTag == 1 ? 'menuListHover' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "./about.html?id=1"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.synopsis))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=2"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.develop))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=3"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.honor))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=4"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.team))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 3 ? 'menuListAct' : '',
	    on: {
	      "mouseenter": function($event) {
	        return _vm.mouseOver(2)
	      },
	      "mouseleave": function($event) {
	        return _vm.mouseLeave()
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.products))]), _vm._v(" "), _c('ul', {
	    staticClass: "menuListCon",
	    class: _vm.tabTag == 2 ? 'menuListTwoHover' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "./productSpring.html"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.spring))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./productHardware.html"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.hardware))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 4 ? 'menuListAct' : '',
	    on: {
	      "mouseenter": function($event) {
	        return _vm.mouseOver(3)
	      },
	      "mouseleave": function($event) {
	        return _vm.mouseLeave()
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.technology))]), _vm._v(" "), _c('ul', {
	    staticClass: "menuListCon",
	    class: _vm.tabTag == 3 ? 'menuListHover' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "./technology.html?id=1"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.echnicalAdvantages))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=2"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.productionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=3"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.inspectionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=4"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.workshopEnvironment))])])])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./contact.html"
	    }
	  }, [_c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 5 ? 'menuListAct' : ''
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.contact))])])])]), _vm._v(" "), _vm._m(1)])]) : _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "menuButton"
	  }, [_c('img', {
	    staticClass: "menuTab",
	    attrs: {
	      "src": __webpack_require__(14),
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.maskTag = true
	      }
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.maskTag) ? _c('div', {
	    staticClass: "mask",
	    on: {
	      "click": function($event) {
	        _vm.maskTag = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.maskTag) ? _c('div', {
	    staticClass: "mian"
	  }, [_c('ul', {
	    staticClass: "menuCon"
	  }, [_c('a', {
	    staticClass: "menuList",
	    attrs: {
	      "href": "./index.html"
	    }
	  }, [_c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 1 ? 'menuListAct' : ''
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.index))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 2 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.menuListTag == 1 ? _vm.menuListTag = 0 : _vm.menuListTag = 1
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.about) + "\n      ")]), _vm._v(" "), (_vm.menuListTag == 1) ? _c('ul', {
	    staticClass: "menuListCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./about.html?id=1"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.synopsis))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=2"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.develop))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=3"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.honor))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=4"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.team))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 3 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.menuListTag == 2 ? _vm.menuListTag = 0 : _vm.menuListTag = 2
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.products) + "\n      ")]), _vm._v(" "), (_vm.menuListTag == 2) ? _c('ul', {
	    staticClass: "menuListCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./productSpring.html"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.spring))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./productHardware.html"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.hardware))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.menuType == 4 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.menuListTag == 3 ? _vm.menuListTag = 0 : _vm.menuListTag = 3
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.technology) + "\n      ")]), _vm._v(" "), (_vm.menuListTag == 3) ? _c('ul', {
	    staticClass: "menuListCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./technology.html?id=1"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.echnicalAdvantages))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=2"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.productionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=3"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.inspectionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=4"
	    }
	  }, [_c('li', {
	    staticClass: "menuTab"
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.workshopEnvironment))])])]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "menuList",
	    attrs: {
	      "href": "./contact.html"
	    }
	  }, [_c('div', {
	    class: _vm.menuType == 5 ? 'menuListAct' : ''
	  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.contact))])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "./index.html"
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(4),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "language",
	    attrs: {
	      "href": "/en/index.html"
	    }
	  }, [_c('p', [_vm._v("中/EN")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "./index.html"
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(4),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "language",
	    attrs: {
	      "href": "/en/index.html"
	    }
	  }, [_c('p', [_vm._v("中/EN")])])
	}]}

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.windowWidth >= 800) ? _c('div', {
	    staticClass: "Footer"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "infoCon"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerAbout))]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=1"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSynopsis))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=2"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerDevelop))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=3"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHonor))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=4"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTeam))])])]), _vm._v(" "), _c('div', {
	    staticClass: "infoCon"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerProducts))]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./productSpring.html"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSpring))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./productHardware.html"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHardware))])])]), _vm._v(" "), _c('div', {
	    staticClass: "infoCon"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTechnology))]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=1"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerEchnicalAdvantages))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=2"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerProductionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=3"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerInspectionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=4"
	    }
	  }, [_c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerWorkshopEnvironment))])])]), _vm._v(" "), _c('div', {
	    staticClass: "infoCon special"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerContact))]), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTel))]), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerEmail))]), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerAddress))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "footerInfo"
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerInfo))])])]) : _c('div', {
	    staticClass: "Footer"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(4),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "titleCon",
	    on: {
	      "click": function($event) {
	        _vm.menuTag == 1 ? _vm.menuTag = 0 : _vm.menuTag = 1
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerAbout))]), _vm._v(" "), _c('img', {
	    staticClass: "arro",
	    class: _vm.menuTag == 1 ? 'arroAct' : '',
	    attrs: {
	      "src": __webpack_require__(5),
	      "alt": ""
	    }
	  })]), _vm._v(" "), (_vm.menuTag == 1) ? _c('div', {
	    staticClass: "menuCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./about.html?id=1"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSynopsis))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=2"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerDevelop))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=3"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHonor))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./about.html?id=4"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTeam))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "titleCon",
	    on: {
	      "click": function($event) {
	        _vm.menuTag == 2 ? _vm.menuTag = 0 : _vm.menuTag = 2
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerProducts))]), _vm._v(" "), _c('img', {
	    staticClass: "arro",
	    class: _vm.menuTag == 2 ? 'arroAct' : '',
	    attrs: {
	      "src": __webpack_require__(5),
	      "alt": ""
	    }
	  })]), _vm._v(" "), (_vm.menuTag == 2) ? _c('div', {
	    staticClass: "menuCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./productSpring.html"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSpring))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./productHardware.html"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHardware))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "titleCon",
	    on: {
	      "click": function($event) {
	        _vm.menuTag == 3 ? _vm.menuTag = 0 : _vm.menuTag = 3
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerTechnology))]), _vm._v(" "), _c('img', {
	    staticClass: "arro",
	    class: _vm.menuTag == 3 ? 'arroAct' : '',
	    attrs: {
	      "src": __webpack_require__(5),
	      "alt": ""
	    }
	  })]), _vm._v(" "), (_vm.menuTag == 3) ? _c('div', {
	    staticClass: "menuCon"
	  }, [_c('a', {
	    attrs: {
	      "href": "./technology.html?id=1"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerEchnicalAdvantages))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=2"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerProductionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=3"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerInspectionEquipment))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "./technology.html?id=4"
	    }
	  }, [_c('div', {
	    staticClass: "menuList"
	  }, [_vm._v(_vm._s(_vm.copyData.footer.footerWorkshopEnvironment))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "titleCon contact"
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerContact))])]), _vm._v(" "), _c('div', {
	    staticClass: "contactInfo"
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerTel))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerEmail))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerAddress))])])]), _vm._v(" "), _c('div', {
	    staticClass: "footerInfo"
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerInfo))])])])
	},staticRenderFns: []}

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAxBJREFUSEu1VjtPFGEUvffbVcAFO5RHotl5CAJCKBhINGqFjdaoia+GEE0IJiqBH6AYNT4qooWiiWKlhRbSoESeWTEiEHEeGwqVHjag2f2OmZEly7KsA8Yppplzv3O/e+49d5iyPAA4Go1WSylrwVzsQhn4IYT4GA6HJ5gZ2eI9fCbA3NxcaD4Wa2WiFmZehJSjYP62TFDKQtQDyANRd0EodK+oqCi2HtEaAsdxDkrgCRENJpivlynKp0zBMzMzNYFgsJ2I9gvmU4qiDGTCrSKwotEmkvIOpDyr6/qbv13f/W6a5hEWooeANk3TetNjVgjczAH0AmjUNG3Sz+FJjGVZVczcJ6U8oev6u9RYj8Ct+UIsNg0hmvVw2Ffm6Qks3+R+fihUkaqJR2CaZgcLsU9T1ZPZMo9EItsk8BKAVW8Y59Oxlm0/hZSfdV2/lvzGbivajjObiMePlZWVZRQ0CY5EIsUJKceJqAhEdxsMoy2VxHGcagm8UhVld7KFecZxagLAc01Vy/3UfXh4eK8IBPqJaCeIbjUYxqXUOMu2vySYm5Ldx19t+5wADmuadsYPgYsZGhoqDwSDblsWMlGXYRgdKYL3SOa3e1T1oTc3pm13CKICVVU7k6DRsbFZJtq+HiGIEgBymDnfwzDfqK+ru+LpadtXiWheV1VPB4+AiAr0/0WwqRJFIuVBYABAIYi6GrKVaKMij4yMVBBzPzPvYKKbhmFcThdZMDcpyxaz0qaC+aiiKBPZhH4/Pl6yJR7/kK1NE1K+1lR110qbesI4TicDVX4GLQG8YMAyDONCpkETzJOKorhC/9HffU1NTeXn5OZOQcpmvyaXfrjjOI0SePBzaamysrJyYRXBsl0cYiGe/QIaKzZodtOWVbWVuQ/rmV3KkBwn5tubsOtHBFzMatdJEtM03Zs8JmBQCNG1nvCu7ySAdiY6AClPp9v0mhKl1tS171gs1gqiFiJaJOYRktJbmSREKQENRJTHRN2hja7MVKKVpc9ci3i8xOuKYPC7AP5t6fs1PT+4jH8VfgL9Yn4DmzKdKOYdmV0AAAAASUVORK5CYII="

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(13);
	
	var _vue = __webpack_require__(1);
	
	var _Footer = __webpack_require__(15);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(16);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _zh = __webpack_require__(3);
	
	var _en = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _vue.defineComponent)({
	  name: 'app',
	  components: {
	    Footer: _Footer2.default,
	    Header: _Header2.default
	  },
	
	  setup: function setup() {
	    var copyData = (0, _vue.ref)({});
	    var breadcrumb = (0, _vue.ref)('压簧系列');
	
	    var tabTag = (0, _vue.ref)(1);
	
	    var getLanguage = function getLanguage() {
	      copyData.value = _zh.chinese;
	    };
	
	    var windowWidth = (0, _vue.ref)(document.body.clientWidth);
	    var swiperIndex = (0, _vue.ref)(-1);
	    var imgListOne = [{ url: __webpack_require__(487) }, { url: __webpack_require__(488) }, { url: __webpack_require__(489) }, { url: __webpack_require__(490) }, { url: __webpack_require__(491) }, { url: __webpack_require__(492) }, { url: __webpack_require__(493) }, { url: __webpack_require__(494) }, { url: __webpack_require__(495) }, { url: __webpack_require__(496) }, { url: __webpack_require__(497) }, { url: __webpack_require__(498) }, { url: __webpack_require__(499) }];
	
	    var imgListTwo = [{ url: __webpack_require__(500) }, { url: __webpack_require__(501) }, { url: __webpack_require__(502) }, { url: __webpack_require__(503) }, { url: __webpack_require__(504) }, { url: __webpack_require__(505) }, { url: __webpack_require__(506) }, { url: __webpack_require__(507) }, { url: __webpack_require__(508) }, { url: __webpack_require__(509) }];
	
	    var imgListThree = [{ url: __webpack_require__(514) }, { url: __webpack_require__(511) }, { url: __webpack_require__(512) }, { url: __webpack_require__(513) }, { url: __webpack_require__(510) }, { url: __webpack_require__(515) }, { url: __webpack_require__(516) }, { url: __webpack_require__(517) }, { url: __webpack_require__(518) }, { url: __webpack_require__(519) }];
	
	    var imgListFour = [{ url: __webpack_require__(520) }, { url: __webpack_require__(521) }, { url: __webpack_require__(522) }, { url: __webpack_require__(523) }, { url: __webpack_require__(524) }, { url: __webpack_require__(525) }, { url: __webpack_require__(526) }, { url: __webpack_require__(527) }, { url: __webpack_require__(528) }, { url: __webpack_require__(529) }];
	
	    var imgListFive = [{ url: __webpack_require__(530) }, { url: __webpack_require__(531) }, { url: __webpack_require__(532) }, { url: __webpack_require__(533) }, { url: __webpack_require__(534) }, { url: __webpack_require__(535) }, { url: __webpack_require__(536) }, { url: __webpack_require__(537) }, { url: __webpack_require__(538) }, { url: __webpack_require__(539) }];
	
	    var swiperListTwo = [{ url: __webpack_require__(543) }, { url: __webpack_require__(544) }, { url: __webpack_require__(545) }, { url: __webpack_require__(546) }, { url: __webpack_require__(547) }, { url: __webpack_require__(548) }, { url: __webpack_require__(549) }, { url: __webpack_require__(550) }, { url: __webpack_require__(551) }, { url: __webpack_require__(552) }];
	
	    var swiperListFour = [{ url: __webpack_require__(553) }, { url: __webpack_require__(554) }, { url: __webpack_require__(555) }, { url: __webpack_require__(556) }, { url: __webpack_require__(557) }, { url: __webpack_require__(558) }, { url: __webpack_require__(559) }, { url: __webpack_require__(560) }, { url: __webpack_require__(561) }, { url: __webpack_require__(562) }];
	
	    var swiperListFive = [{ url: __webpack_require__(563) }, { url: __webpack_require__(564) }, { url: __webpack_require__(565) }, { url: __webpack_require__(566) }, { url: __webpack_require__(567) }, { url: __webpack_require__(568) }, { url: __webpack_require__(569) }, { url: __webpack_require__(570) }, { url: __webpack_require__(571) }, { url: __webpack_require__(572) }];
	
	    var getPosition = function getPosition() {
	      if (windowWidth.value >= 800) {
	        if (document.body.scrollTop > 750 || document.documentElement.scrollTop > 750) {
	          document.body.scrollTop = 750;
	          document.documentElement.scrollTop = 750;
	        }
	      } else {
	        document.body.scrollTop = 0;
	        document.documentElement.scrollTop = 0;
	      }
	    };
	
	    var goBackToTop = function goBackToTop() {
	      window.addEventListener('scroll', function (e) {});
	    };
	
	    var handleShowTop = function handleShowTop() {
	      var sc = window.scrollY;
	      if (sc > 100) {
	        document.querySelector('.scroll-top').classList.add('show');
	      } else {
	        document.querySelector('.scroll-top').classList.remove('show');
	      }
	    };
	
	    var backToTop = function backToTop() {
	      window.scroll({
	        top: 0,
	        behavior: 'smooth'
	      });
	    };
	
	    (0, _vue.onMounted)(function () {
	      goBackToTop();
	    });
	
	    getLanguage();
	    breadcrumb.value = copyData.value.spring.menulist01;
	    return {
	      chinese: _zh.chinese,
	      english: _en.english,
	      copyData: copyData,
	      getLanguage: getLanguage,
	      windowWidth: windowWidth,
	      breadcrumb: breadcrumb,
	      tabTag: tabTag,
	      imgListOne: imgListOne,
	      swiperIndex: swiperIndex,
	      imgListTwo: imgListTwo,
	      imgListThree: imgListThree,
	      imgListFour: imgListFour,
	      imgListFive: imgListFive,
	      swiperListTwo: swiperListTwo,
	      swiperListFour: swiperListFour,
	      swiperListFive: swiperListFive,
	      getPosition: getPosition,
	      goBackToTop: goBackToTop,
	      backToTop: backToTop
	    };
	  }
	});

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/101.78c7788.png";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/102.7c035b5.png";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/103.dba3e8a.png";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/104.ce2abe6.png";

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/105.c62d36b.png";

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/106.518e525.png";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/107.f514a20.png";

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/108.8d8a091.png";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/109.2324add.png";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/110.d0ae145.png";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/111.9d2a2af.png";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/112.9f0c041.png";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/113.ca10836.png";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/201.69d7f8b.png";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/202.207fc78.png";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/203.4a3554d.png";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/204.d94b856.png";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/205.314dc26.png";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/206.c6ff48f.png";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/207.40de81b.png";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/208.3171cd2.png";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/209.d0eb7f6.png";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/210.7ca5c11.png";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/301.b9fafd6.png";

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/302.835b006.png";

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/303.6197c68.png";

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/304.e4c29c2.png";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/305.b1f8b85.png";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/306.4579c7a.png";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/307.17d0de6.png";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/308.b8f3e37.png";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/309.a3f74f1.png";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/310.73827b4.png";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/401.064a635.png";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/402.9e29b69.png";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/403.7fa1618.png";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/404.236147b.png";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/405.63e6711.png";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/406.36f4ce2.png";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/407.4d9ccdf.png";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/408.9f1efd3.png";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/409.d12261e.png";

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/410.a7b10e4.png";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/501.fce0ec2.png";

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/502.ff4c150.png";

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/503.52f52ce.png";

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/504.57e843f.png";

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/505.ecdaa0d.png";

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/506.2a302eb.png";

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/507.5e740e6.png";

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/508.254648d.png";

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/509.c298ddf.png";

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/510.1e02c5b.png";

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAA6BJREFUeF7t28+rTVEUwPHv4hFlKCXJj5kSksEb+FEUBn4MKAOlKCUUJgZiIjMMpF4pUiIDJvJjZEKJRzymIu+VfwAjoaWt83Td7o+z39rnnH21zvTutc9an7POuffuc47gm0lATNEejAMam8ABHdAoYAz3DnRAo4Ax3DvQAY0CxvCsO1BVZwCzReSrsc7KwrMFLPDuAPOBzSLypTIFw8RZArbg7Sxqe5krYnaAHfAm+yNLxKwAe+Bli5gNYAm8LBGzAIzAyw6xccAp4GWF2CigAS8bxMYAE+BlgdgIYIF3F9hh+A3bGtrYT5zaASvAa7QTawWsEK8xxNoAI/BeATOBlW2n9zhwDzjW57Sv9XSuBTAC70/xwH1gXTugiCxR1cvA0VwQKweMxQurLqr6tAdgyHkEOJQDYqWAEXijwJbJJategAFNVUPeV4CDTSNWBhiJF9b7/i6a9gNsQbwG7G8SsRLACLwXRef9s+JcBrBAnAZcB/Y1hZgc0IpXwHS6Bk6IyOJ2KFUNiDeAvU0gJgWMwHsObO12r6NLB3YELMCnA7eAPXUjJgOMxAtfGN+6FRsLWCAOAbeB3XUiJgGMwHsCbO+FF3sKt2Kpau2IqQB3AeEOWrf5FLgAnBKRn/0WEKbSgZNzFtfE88CJHvmE4cdF5FK/XPp9ngSw6JrwD+IisLxtp2PAaRF51C+ZFoTSXyI9LgPrgbPAhrYxE0U+N8vm02tcMsCW4lcAy4DQae9E5ENsopYO7PAtvRBYDcwCPgJjIvIrNqdu45MDpkgsJWCKfGrtwBQJO6BR0QEd0ChgDPcOdECjgDHcO9ABjQLGcO9ABzQKGMO9Ax3QKGAM9w50QKOAMdw70AGNAsZw70AHNAoYw8s+mWDcTZLwQVrSHw+PtyWpOuEkuQKG5wO3tdXpgGUPvKqG25FnHLCsWNs4VV0AvAHmtXz0SUSWTnHKysKyPIVDtaoabow/BOYU1TtgbBuo6lzgJLARGBKRVbFzVD0+2w6suvBU8zugUdIBHdAoYAz3DvwfAVX1AbAIeA2cm8ojckaX0uFZdqCqPgY2FVX8AA6LyNXSVdU4cBAAA8d3YFhE3tZoU2pXgwIYihkRkSOlqqpx0CABjorIcI02pXY1SICfRSQ875zV5oDGw+GA/ylgeI31QFttz0RkrbHe5OG5dmC41oUXYdYA4W3M9+G9YBEJi6xZbVkCZiXUJxkHNB4tB3RAo4Ax3DvQCPgb0wDOYF1qZIkAAAAASUVORK5CYII="

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/banner.b0dde43.png";

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAAAXNSR0IArs4c6QAAA3NJREFUSEu1ll+IVVUUxr/vXCXHmTv2UklPRVOEyBQNOXPP3tpLIUUvUihUML0YQWoEQQ1E0j/6QyWRRhSiQgZqYWAYUcQIa52r5K0YhnlpqIcgrhGWc+/YiNyz4lzuORxn7tVT0Xk8e6/1W2t/a6+1id5fyTm3EcAmkBUzu5Fkn5n9RfJnmFUBHFXVLwG0erlhtwXv/SYDXjPgTwM+ZhyfaDabP05NTc0PDw/3DwwM3GxBcBeBhwhcTeBZETnazdclgKGhoauuW736AwCjBLaJyNeXybC95L2/24DdAE6dqdcfm52dvZC3yQAd558nUTfn5h5Nor2S83S9ndXg4P4kmzP1+v15SAZw3h8wYGUksgVAXNR5bl8Qen+IwHkVGU//twGdM3+1MTc3kkbunLsXwASASVV9vggwyaQ8OFgjMJFqkgBKzvsZAk+kZ+6c2wLybYvjHSSfAXBYVd8sAuloskdF1iTVRefcfUbujERGUwehc0kZbo6i6NuxsbEbglLpdECuE5GfikBC70/R7AVVPZ4APozJ6arIOzlAncAdqvpr8i/0/mUAKyKRp4sAKt4/GZitVdWtdN5PWxw/EkXRD6mx8/5gDERVkT0dwBGaRaq6qwggDMPbGQQfqchahs7NNxuNa/NlGYbhnQyCT/84e3bNzMxMM3Tuu5jceVLkWBFAu2zL5d8i1f4kg1hFgsWGofd7aXZRVR8Pw3ADg+CTuNXaWK1Wvy8CSf12zSBx4JwrgzwNszdUdW+4fv2DNHsPZhNGJgVxTQC8JSKyGLg4gyUapAbe+1sMOBEDO6oiR8a8Hw2A55K2QLNfQL4Is2MLCwtP1Wq1i1mR5DXoVkX5iNZ5f9ty4IsYeCUVPV0fGRlZtaKvbx/MTFUfSP9fWkVd7sESPcLwJpCfgZy+sGzZ9trk5O+Zs0rl1qBU+kZFrs8yyN+D9CbDbJuqftVLwEql0sdS6SUC4zDb1yKPs9UyBsEukIcikdc72t0Dcnd2k3v1ol6gzs3eSnIDgOUw26+q7yf7e/Witq92NzXrj1Q3/+tu6txhkvNLumkCyOaB2blmozH+j+dBuXyA5Kqe8yAHaU80mG2/nCZZW3EuOfN3rzjR8meezWSzc0Ye7DmTzR5Ooi48kxcJ2+1VsdLMzv/nV0WRXlN0T9dnS1HjIvv+d8DfP4/rKun2CHUAAAAASUVORK5CYII="

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s201.d503dbc.png";

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s202.7ccc3bf.png";

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s203.9853a8f.png";

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s204.9de59ea.png";

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s205.1476129.png";

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s206.1b2172e.png";

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s207.4659fc2.png";

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s208.ba6fd8d.png";

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s209.5930b09.png";

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s210.d14037a.png";

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s401.64df13d.png";

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s402.64df13d.png";

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s403.fb33e65.png";

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s404.3e05c54.png";

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s405.034c683.png";

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s406.19167b3.png";

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s407.6ad3ae7.png";

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s408.f383820.png";

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s409.6622fbb.png";

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s410.0283b53.png";

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s501.42ca7b0.png";

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s502.7fe0ba8.png";

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s503.261f0a4.png";

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s504.65de442.png";

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s505.0bdf946.png";

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s506.098a9b1.png";

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s507.c91ebd3.png";

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s508.bbbf880.png";

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s509.2daaa39.png";

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/s510.5a05c09.png";

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(234)
	
	/* script */
	__vue_exports__ = __webpack_require__(177)
	
	/* template */
	var __vue_template__ = __webpack_require__(599)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-159a54fc"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('Header'), _vm._v(" "), _c('div', {
	    staticClass: "banner"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(541),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bannerCon"
	  }, [_c('p', {
	    staticClass: "bannerTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.bannerTitleZH))]), _vm._v(" "), _c('p', {
	    staticClass: "bannerSubtitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.bannerTitleEN))])])]), _vm._v(" "), _c('p', {
	    staticClass: "breadcrumb"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.breadcrumb) + _vm._s(_vm.breadcrumb))]), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  }, [(_vm.windowWidth >= 800) ? _c('div', {
	    staticClass: "leftCon"
	  }, [_c('div', {
	    staticClass: "titleCon"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleZH))]), _vm._v(" "), _c('p', {
	    staticClass: "titleEN"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleEN))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuCon"
	  }, [_c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 1 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 1, _vm.breadcrumb = _vm.copyData.spring.menulist01, _vm.swiperIndex = -1, _vm.getPosition()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(35),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist01))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 2 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 2, _vm.breadcrumb = _vm.copyData.spring.menulist02, _vm.swiperIndex = -1, _vm.getPosition()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(35),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist02))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 3 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 3, _vm.breadcrumb = _vm.copyData.spring.menulist03, _vm.swiperIndex = -1, _vm.getPosition()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(35),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist03))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 4 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 4, _vm.breadcrumb = _vm.copyData.spring.menulist04, _vm.swiperIndex = -1, _vm.getPosition()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(35),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist04))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 5 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 5, _vm.breadcrumb = _vm.copyData.spring.menulist05, _vm.swiperIndex = -1, _vm.getPosition()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(35),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist05))])]), _vm._v(" "), _c('div', {
	    staticClass: "phoneCon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(542),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.phoneTitle))]), _vm._v(" "), _c('p', {
	    staticClass: "phoneNum"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.phoneNum))])])])]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 800) ? _c('div', {
	    staticClass: "leftCon"
	  }, [_c('div', {
	    staticClass: "menuCon"
	  }, [_c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 1 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 1, _vm.breadcrumb = _vm.copyData.spring.menulist01, _vm.swiperIndex = -1
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist01))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 2 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 2, _vm.breadcrumb = _vm.copyData.spring.menulist02, _vm.swiperIndex = -1
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist02))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 3 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 3, _vm.breadcrumb = _vm.copyData.spring.menulist03, _vm.swiperIndex = -1
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist03))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 4 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 4, _vm.breadcrumb = _vm.copyData.spring.menulist04, _vm.swiperIndex = -1
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist04))])]), _vm._v(" "), _c('div', {
	    staticClass: "menuList",
	    class: _vm.tabTag == 5 ? 'menuListAct' : '',
	    on: {
	      "click": function($event) {
	        _vm.tabTag = 5, _vm.breadcrumb = _vm.copyData.spring.menulist05, _vm.swiperIndex = -1
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist05))])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 1) ? _c('div', {
	    staticClass: "rightCon"
	  }, [(_vm.swiperIndex == -1) ? _c('div', {
	    staticClass: "mainCon"
	  }, [_c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextOne))]), _vm._v(" "), _c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextTwo))]), _vm._v(" "), _c('div', {
	    staticClass: "listCon"
	  }, _vm._l((_vm.imgListOne), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "listMain",
	      on: {
	        "click": function($event) {
	          _vm.swiperIndex = index, _vm.getPosition()
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
	    staticClass: "swiper"
	  }, [_c('el-carousel', {
	    attrs: {
	      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
	      "width": "100%",
	      "indicator-position": "none",
	      "arrow": "always",
	      "autoplay": false,
	      "initial-index": _vm.swiperIndex
	    }
	  }, _vm._l((_vm.imgListOne), function(item) {
	    return _c('el-carousel-item', {
	      key: item
	    }, [_c('div', {
	      staticClass: "swiperList"
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])])
	  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 2) ? _c('div', {
	    staticClass: "rightCon"
	  }, [(_vm.swiperIndex == -1) ? _c('div', {
	    staticClass: "mainCon"
	  }, [_c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextThree))]), _vm._v(" "), _c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextFour))]), _vm._v(" "), _c('div', {
	    staticClass: "listCon"
	  }, _vm._l((_vm.imgListTwo), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "listMain",
	      on: {
	        "click": function($event) {
	          _vm.swiperIndex = index, _vm.getPosition()
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
	    staticClass: "swiper"
	  }, [_c('el-carousel', {
	    attrs: {
	      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
	      "width": "100%",
	      "indicator-position": "none",
	      "arrow": "always",
	      "autoplay": false,
	      "initial-index": _vm.swiperIndex
	    }
	  }, _vm._l((_vm.swiperListTwo), function(item) {
	    return _c('el-carousel-item', {
	      key: item
	    }, [_c('div', {
	      staticClass: "swiperList"
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])])
	  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 3) ? _c('div', {
	    staticClass: "rightCon"
	  }, [(_vm.swiperIndex == -1) ? _c('div', {
	    staticClass: "mainCon"
	  }, [_c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextFive))]), _vm._v(" "), _c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextSix))]), _vm._v(" "), _c('div', {
	    staticClass: "listCon"
	  }, _vm._l((_vm.imgListThree), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "listMain",
	      on: {
	        "click": function($event) {
	          _vm.swiperIndex = index, _vm.getPosition()
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
	    staticClass: "swiper"
	  }, [_c('el-carousel', {
	    attrs: {
	      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
	      "width": "100%",
	      "indicator-position": "none",
	      "arrow": "always",
	      "autoplay": false,
	      "initial-index": _vm.swiperIndex
	    }
	  }, _vm._l((_vm.imgListThree), function(item) {
	    return _c('el-carousel-item', {
	      key: item
	    }, [_c('div', {
	      staticClass: "swiperList"
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])])
	  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 4) ? _c('div', {
	    staticClass: "rightCon"
	  }, [(_vm.swiperIndex == -1) ? _c('div', {
	    staticClass: "mainCon"
	  }, [_c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextSeven))]), _vm._v(" "), _c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextEight))]), _vm._v(" "), _c('div', {
	    staticClass: "listCon"
	  }, _vm._l((_vm.imgListFour), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "listMain",
	      on: {
	        "click": function($event) {
	          _vm.swiperIndex = index, _vm.getPosition()
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
	    staticClass: "swiper"
	  }, [_c('el-carousel', {
	    attrs: {
	      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
	      "width": "100%",
	      "indicator-position": "none",
	      "arrow": "always",
	      "autoplay": false,
	      "initial-index": _vm.swiperIndex
	    }
	  }, _vm._l((_vm.swiperListFour), function(item) {
	    return _c('el-carousel-item', {
	      key: item
	    }, [_c('div', {
	      staticClass: "swiperList"
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])])
	  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 5) ? _c('div', {
	    staticClass: "rightCon"
	  }, [(_vm.swiperIndex == -1) ? _c('div', {
	    staticClass: "mainCon"
	  }, [_c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextNine))]), _vm._v(" "), _c('p', {
	    staticClass: "rightTitle"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
	    staticClass: "rightText"
	  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextNine))]), _vm._v(" "), _c('div', {
	    staticClass: "listCon"
	  }, _vm._l((_vm.imgListFive), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "listMain",
	      on: {
	        "click": function($event) {
	          _vm.swiperIndex = index, _vm.getPosition()
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
	    staticClass: "swiper"
	  }, [_c('el-carousel', {
	    attrs: {
	      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
	      "width": "100%",
	      "indicator-position": "none",
	      "arrow": "always",
	      "autoplay": false,
	      "initial-index": _vm.swiperIndex
	    }
	  }, _vm._l((_vm.swiperListFive), function(item) {
	    return _c('el-carousel-item', {
	      key: item
	    }, [_c('div', {
	      staticClass: "swiperList"
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    })])])
	  }), 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('div', {
	    staticClass: "scroll-top",
	    on: {
	      "click": _vm.backToTop
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(540)
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/module/productSpring.d108e41896d2712c3f82.js